import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import MobileDetect from "mobile-detect";
import axios from "axios";
//import Currency from "currency-formatter";
import JSEncrypt from "jsencrypt";
import CryptoJS from "crypto-js";
import isNil from "lodash/isNil";
import get from "lodash/get";
import moment from "moment";
import each from "lodash/each";
import map from "lodash/map";
import reduce from "lodash/reduce";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import filter from "lodash/filter";
import trim from "lodash/trim";
import trimStart from "lodash/trimStart";
import head from "lodash/head";
import includes from "lodash/includes";
import split from "lodash/split";
import sortBy from "lodash/sortBy";
import orderBy from "lodash/orderBy";
import forEach from "lodash/forEach";
import isFunction from "lodash/isFunction";
import isPlainObject from "lodash/isPlainObject";
import compact from "lodash/compact";
import join from "lodash/join";
import startsWith from "lodash/startsWith";
import endsWith from "lodash/endsWith";
import ceil from "lodash/ceil";
import keys from "lodash/keys";
import indexOf from "lodash/indexOf";
import isObject from "lodash/isObject";
import DOMPurify from "dompurify";
import last from "lodash/last";
import some from "lodash/some";
import {
  formatDate as formatDateGlobal,
  CURRENCY_STYLES,
  formatCurrency as formatGlobalCurrency,
  DATE_STYLES
} from "utils/i18nFormatter";
import {
  COUNTRY,
  GOOGLE_API_KEY,
  ECOM_API_KEY,
  ACTION_URLS,
  PAYMENT_STATUS_URLS,
  PAYMENT_STATUS_URLS_CXOS,
  paths,
  RESTRICTED_STEP_ACTIONS,
  WEB_CHANNELS,
  WORKFLOW_CHANNELS,
  ONE_TIME_DISCOUNT_TYPES,
  TELCO_BENEFIT_TYPES,
  TELCO_WAIVER_TYPES,
  EXPRESS_DELIVERY,
  DELIVERY_METHOD_TYPE,
  OUTSTANDING_BILL_REFERRAL_FROM_TYPE,
  publicPaths,
  MYINFO_ENDPOINT,
  MYINFO_CLIENT_ID,
  DOB_FORMAT,
  SECURITY_DOB_FORMAT,
  TERMINATE_ACTION_STATUS,
  TERMINATION_PENDING_STATUSES,
  PORTOUT_PENDING_STATUSES,
  PORTOUT_IN_PROGRESS,
  PORTOUT_FAILED_STATUSES,
  PORTOUT_COMPLETED_STATUSES,
  MOBILE_APP_DEEP_LINK_QA,
  MOBILE_APP_DEEP_LINK,
  PORTING_ACCOUNTS,
  UPDATE_TOKEN_TO_APP_URI,
  MOBILE_APP_BROWSER_PROTOCOL,
  SPECIAL_DELIVERY,
  SIGNINTYPE,
  ORDER_ACTION_TYPES,
  ORDER_STATUS,
  PORTIN_NUMBER_VERFICATION,
  TERMINATION_COMPLETED_STATUS,
  TELCO_ACTIVATION_FAILED,
  FILE_TYPE_MAP,
  BROWSER_PERMISSION_QUERY_NAMES,
  SHIPMENT_METHOD,
  TELCO_STATUS,
  ZENDESK_CHAT_ACCOUNT_KEY,
  SEND_DATA_TO_APP_URI,
  DATA_VALUE_TYPE,
  DATA_BUNDLE,
  ORDER_TYPES,
  ELIGIBLE_ORDER_STUTSES,
  TELCO_ACTIVATION_SUCCESS,
  JOURNEY_FLOW,
  GROUP_PRODUCT_FREQUENCY_MAPPING,
  AWS_IMAGE_PATH,
  WEBFRONT_V2_URL
} from "utils/constants";

import history from "./history";
import queryString from "query-string";
import Sha256 from "crypto-js/sha256";
import Hex from "crypto-js/enc-hex";
import floor from "lodash/floor";
import {
  getLocaleOrDefault,
  getDeviceId,
  isActivationSuccess,
  isWebview,
  getItem,
  getWebview,
  getLandingPage,
  isQAApp,
  isNative,
  updatePageLoadTime
} from "./localStorage";
import isArray from "lodash/isArray";
import scrollIntoView from "scroll-into-view-if-needed";
import { SIM_TYPES } from "utils/constants";

// const PHONE_ORDER = {
//   huawei: 3,
//   samsung: 2,
//   iphone: 1
// };

// export const sortPhones = phones => {
//   return phones
//     .sort((next, prev) => {
//       const nextKey = Object.keys(PHONE_ORDER).find(k => {
//         return next.name.toLowerCase().includes(k);
//       });

//       const nextPriority = PHONE_ORDER[nextKey];

//       const prevKey = Object.keys(PHONE_ORDER).find(k => {
//         return prev.name.toLowerCase().includes(k);
//       });
//       const prevPriority = PHONE_ORDER[prevKey];

//       return nextPriority > prevPriority ? -1 : 1;
//     })
//     .sort((next, prev) => {
//       return next.out_of_stock === prev.out_of_stock
//         ? 0
//         : next.out_of_stock
//         ? 1
//         : -1;
//     });
// };

export const randomNumber = () => {
  const min = 1111111;
  const max = 9999999;
  return Math.floor(Math.random() * (max - min)) + min;
};

export const minutesDifference = (t1, t2) => {
  const diff = t1 - t2;
  return Math.floor(diff / 1000 / 60);
};

export const upper = value => value && value.toUpperCase();
export const lower = value => value && value.toLowerCase();

export const isPostalCodeResult = results => {
  let isPostalCodeSearch = false;
  const address = results[0];
  const types = address.types;
  const searchType = types.filter(type => type === "postal_code");
  isPostalCodeSearch = searchType !== null && searchType.length > 0;
  return isPostalCodeSearch;
};

const parseAddress = results => {
  const {
    address_components: addressComponents,
    formatted_address: formattedAddress
  } = head(results) || {};

  let subPremise;
  let premise;
  let subLocality2;
  let subLocality3;
  let subLocality4;
  let blockHouseNo;
  let streetName;
  let postalCode;
  let country;

  const items = [
    ["subPremise", "subpremise", "long_name"],
    ["premise", "premise", "long_name"],
    ["subLocality2", "sublocality_level_2", "long_name"],
    ["subLocality3", "sublocality_level_3", "long_name"],
    ["subLocality4", "sublocality_level_4", "long_name"],
    ["blockHouseNo", "street_number", "long_name"],
    ["streetName", "route", "long_name"],
    ["postalCode", "postal_code", "long_name"],
    ["city", "locality", "long_name"],
    ["state", "administrative_area_level_1", "short_name"],
    ["country", "country", "long_name"]
  ];

  const result = items.reduce(
    (accumulator, item) => {
      let addressComponent = addressComponents.filter(component =>
        includes(component.types, item[1])
      );

      if (addressComponent !== null && addressComponent.length > 0) {
        return { ...accumulator, [item[0]]: addressComponent[0][item[2]] };
      } else {
        return accumulator;
      }
    },
    {
      subPremise,
      premise,
      subLocality2,
      subLocality3,
      subLocality4,
      blockHouseNo,
      streetName,
      postalCode,
      country
    }
  );
  const localityAddress = compactJoin(
    [result.subLocality3, result.subLocality4, premise],
    "-"
  );
  return {
    ...result,
    city: compactJoin([result.city, result.subLocality2]),
    streetName: result.streetName || localityAddress,
    formattedAddress
  };
};

export async function getAddress(addr) {
  let geocodeByAddressResponse = await geocodeByAddress(addr);
  let getLatLngResponse = await getLatLng(geocodeByAddressResponse[0]);

  if (!isPostalCodeResult(geocodeByAddressResponse)) {
    const coords = `${getLatLngResponse.lat},${getLatLngResponse.lng}`;
    const requestUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords}&key=${GOOGLE_API_KEY}`;
    let apiRequest = await axios.get(requestUrl);
    return parseAddress(apiRequest.data.results);
  }

  return parseAddress(geocodeByAddressResponse);
}

export async function getCity(lat, lng) {
  const coords = `${lat},${lng}`;
  const requestUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords}&key=${GOOGLE_API_KEY}`;
  let locationInfo = await axios.get(requestUrl);
  let city =
    locationInfo.data.results
      .flatMap(result => result.address_components)
      .find(component => component.types.includes("locality"))?.long_name ||
    null;
  return city;
}

export const checkLength = value => {
  return value?.toString().length;
};

export const checkAlphabetLetters = value => {
  return /[a-zA-Z]/.test(value);
};

export const getFormattedDeliveryDateAndTime = (
  deliveryDate,
  deliverySlotLabel,
  slotDetails,
  locale
) => {
  return isEmpty(slotDetails) && deliveryDate && deliverySlotLabel
    ? `${formatDateGlobal(new Date(deliveryDate.replace(/-/g, "/")), {
        style: DATE_STYLES.SHORT
      })}, ${deliverySlotLabel}`
    : isEmpty(slotDetails)
    ? get(locale, "slot_details_error_message", "No slot Information Available")
    : `${formatDateGlobal(
        new Date(get(slotDetails, "date", deliveryDate).replace(/-/g, "/")),
        {
          style: DATE_STYLES.SHORT
        }
      )}, ${moment(get(slotDetails, "startTime"), ["HH:mm"]).format(
        "h:mm A"
      )} - ${moment(get(slotDetails, "endTime"), ["HH:mm"]).format("h:mm A")}`;
};

export const urlParam = key => {
  const url = new URL(window.location.href);
  return url && url.searchParams && key ? url.searchParams.get(key) : undefined;
};

export const getURLParams = () => {
  let params = {};
  const query = window.location.search.replace("?", "");
  const vars = query ? query.split("&") : [];
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    params[pair[0]] = decodeURIComponent(pair[1]);
  }

  return params;
};

export const getURLParamValue = param => {
  const params = getURLParams();
  return params[param] === "true" ? true : false;
};

export const addUrlParam = (key, val, currentUrl) => {
  const isParamsAvaialble = currentUrl.split("?").length > 1;
  if (isParamsAvaialble) return `${currentUrl}&${key}=${val}`;
  return `${currentUrl}?${key}=${val}`;
};

export const replaceUrlParam = (currentUrl, paramName, paramValue) => {
  if (!paramValue || !paramName || !currentUrl) return;
  currentUrl = new URL(currentUrl);
  const allParams = getURLParams();
  const paramExists = get(allParams, paramName, false);
  if (isEmpty(allParams) || !paramExists) return;

  currentUrl.searchParams.set(paramName, paramValue);
  window.history.replaceState(null, "", currentUrl);
};

export const isMobile = () => 
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
    );

export const isIOS = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.is("iPhone") || md.is("iPad");
};

export const isIOSSafari = () => {
  var ua = window.navigator.userAgent;
  var webkit = !!ua.match(/WebKit/i);
  return isIOS() && webkit && !ua.match(/CriOS/i);
};

export const isDesktop = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() == null;
};

export const isTabletOrDeskTop = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  return md.mobile() == null || md.tablet();
};

export const allFilled = (object, fields) => {
  if (object === undefined) {
    return false;
  }

  return fields.every(field => {
    if (object[field] === undefined) {
      return false;
    }

    return object[field].length > 0;
  });
};

export const resetAddressField = (change, field) => {
  change(field, "");
};
export const resetAddressFields = (change, type, whitelistFields = []) => {
  // change(`${type}_location`, ""); // not resetting so we can see text in google field as well

  const dict = [
    `${type}_hse_blk_tower`,
    `${type}_street_name`,
    `${type}_building_name`,
    `${type}_unit_no`,
    `${type}_location`,
    `${type}_slot_full_data`,
    `${type}_slot_id`,
    `${type}_slot`,
    "pop_station_outlet_full_data" // no type variable as only available for pop station
  ];

  each(dict, field => {
    if (whitelistFields.indexOf(field) === -1) {
      resetAddressField(change, field);
    }
  });
};

export const setAddress = (
  change,
  type,
  address,
  validatePostalCode,
  data,
  callback,
  props
) => {
  getAddress(address).then(result => {
    const {
      blockHouseNo,
      streetName,
      postalCode,
      city,
      state,
      // country,
      formattedAddress
    } = result;
    // const { topCountries } = props;
    console.log("$$$ setAddress result", result, address);

    if (get(data, "validate", false)) {
      if (!allFilled(result, data.validate)) {
        change(
          `${type}_location_error`,
          "click_here_to_fill_in_your_address_manually"
        );

        resetAddressFields(change, type);
        return;
      } else {
        change(`${type}_location_error`, "");
      }
    } else {
      change(`${type}_location_error`, "");
    }

    // let countryName = find(topCountries, { label: country });
    change(`${type}_location`, formattedAddress || address);
    // change(`${type}_country`, countryName);

    change(`${type}_street_name`, compactJoin([blockHouseNo, streetName], " "));
    change(`${type}_city`, city);
    change(`${type}_state`, state);
    change(`${type}_building_name`, "");
    // change(`${type}_unit_no`, subPremise);
    change(`${type}_zip_code`, postalCode);

    if (type === "delivery") change("can_fetch_delivery_slots", false);
    isFunction(validatePostalCode) &&
      validatePostalCode(postalCode, `${type}_zip_code`);
    isFunction(callback) && callback(result);
  });
};

export const setPostOfficeAddressAsDeliveryAddress = (change, postOffice) => {
  const { full_address, address, delivery_slots } = postOffice;
  change("delivery_location", full_address);
  change("delivery_street_name", address.street_name);
  change("delivery_building_name", address.building_name);
  change("delivery_hse_blk_tower", address.hse_blk_tower);
  change("delivery_zip_code", address.zip_code);
  change("delivery_floor_no", address.floor_no);
  change("delivery_unit_no", address.unit_no);
  change("delivery_city", address.city);

  // change("delivery_country", address.country);
  change("delivery_delivery_note", "");
  change("delivery_slot_id", get(delivery_slots, "0.id", ""));
  change("delivery_slot_fee", get(delivery_slots, "0.cost", 0));
  change("delivery_date", get(delivery_slots, "0.date_string", ""));
  change("delivery_slot", get(delivery_slots, "0.courier_slot_name", ""));
  change("same_as_delivery_address", false);
};

export const prepareImageDataForUpload = (file, binaryStr) => {
  const data = binaryStr.split(";");
  const fileType = data[0].split("data:")[1];
  const base64ImageData = data[1].split("base64,")[1];

  return {
    content_type: fileType,
    data: base64ImageData,
    file_name: file.name
  };
};

export const prepareScreenshotDataForUpload = (file, binaryStr) => {
  const data = binaryStr.split(";");
  const fileType = data[0].split("data:")[1];
  const base64ImageData = data[1].split("base64,")[1];

  return {
    content_type: fileType,
    data: base64ImageData,
    file_name: file.name,
    browser_details: getBrowser(),
    ip_address: "127.0.0.1"
  };
};

const getBrowser = () => {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR\/(\d+)/);

    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }

  return {
    name: M[0],
    version: M[1]
  };
};

// export const formatCurrency = (amount, format, forceSign, forcedPrecision) => {
//   if (isNil(amount) || !format) return null;
//   const prefix = forceSign ? (amount < 0 ? "-" : amount > 0 ? "+" : "") : "";
//   const precision = isNaN(forcedPrecision) ? format.precision : forcedPrecision;
//   const formattedCurrency = Currency.format(amount, { ...format, precision });
//   return !prefix || formattedCurrency.startsWith(prefix)
//     ? formattedCurrency
//     : `${prefix} ${formattedCurrency}`;
// };
export const formatCurrency = (
  amount,
  format,
  forceSign,
  forcedPrecision,
  style = { style: CURRENCY_STYLES.LONG }
) => {
  return formatGlobalCurrency(amount, style);
};

export const formatDisplayNumber = (number, format) => {
  const pattern = get(format, "pattern", "");
  const zeroPadded = get(format, "zero_padded", false);
  let numberArray = trim(number).split("");
  let patternArray;

  // pattern key can contain array of patterns:string or just one pattern:string
  if (Array.isArray(pattern)) {
    patternArray = pattern
      .find(pat => {
        // remove the white spaces and get masking characters to determine the correct
        // formatting pattern for the given number
        return pat.replace(/\W/gm, "")?.length === numberArray.length;
      })
      ?.split("");
  } else {
    patternArray = pattern.split("");
  }

  if (!zeroPadded && numberArray[0] === "0") {
    numberArray.shift();
  }

  const result = numberArray.reduce(
    (accumulator, currentValue = "") => {
      let concatString = "";
      let index = accumulator.index;
      let nextIndex = 0;
      let string = accumulator.string;
      let patternString = patternArray?.[index] || "";

      if (patternString === "X") {
        concatString = concatString + currentValue;
      } else {
        nextIndex = nextIndex + 1;
        concatString = patternString + concatString + currentValue;
      }

      nextIndex = nextIndex + 1;

      return {
        index: index + nextIndex,
        string: string + concatString
      };
    },
    { index: 0, string: "" }
  );

  return result.string;
};

export const containsOnlyNumbers = value => {
  // Use a regular expression to check if the value contains only numbers

  // Below regex will accepts whole numbers like 100, numbers with a decimal part like 100.55
  // and numbers that start with a decimal point like .100
  return /^(?:\d+\.\d*|\.\d+|\d+)$/.test(value);
};

export const formatContactNumber = (number, format, countryCode) => {
  const formattedNumber = formatDisplayNumber(number, format);
  const hideCountryCode = get(format, "hide_country_code", false);
  return hideCountryCode
    ? formattedNumber
    : compactJoin([countryCode, trimStart(formattedNumber, "0")], " ");
};

export const formatInvoiceDate = ({
  unix,
  locale,
  monthOptions,
  dateOptions
}) => {
  let formattedInvoiceDate = "";
  let unixCopy = unix;

  if (!unixCopy) return formattedInvoiceDate;
  if (unixCopy.toString().length === 13) unixCopy = Math.floor(unixCopy / 1000);

  const invoiceDateFormat = get(
    locale,
    "invoice_date_format",
    "{yearLabel} {monthLabel} {startDateLabel}-{endDateLabel}"
  );
  const yearFormat = get(locale, "year_label", "{year}");
  const date = new Date(unixCopy * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  // if month is last month then the end month should be january
  const endMonth = month === 12 ? 1 : month + 1;
  // if month is last month then the end year should be next year
  const endYear = month === 12 ? year + 1 : year;

  const startDate = 1;
  const endDate = date.getDate();

  const paddedMonth = month.toString().padStart(2, "0");
  const paddedEndMonth = endMonth.toString().padStart(2, "0");
  const paddedStartDate = startDate.toString().padStart(2, "0");
  const paddedEndDate = endDate.toString().padStart(2, "0");

  const yearLabel = formatMessage(yearFormat, { year });
  const endYearLabel = formatMessage(yearFormat, { year: endYear });
  const monthLabel =
    find(monthOptions, { value: paddedMonth })?.label || paddedMonth;
  const endMonthLabel =
    find(monthOptions, { value: paddedEndMonth })?.label || paddedEndMonth;
  const startDateLabel =
    find(dateOptions, { value: paddedStartDate })?.label || paddedStartDate;
  const endDateLabel =
    find(dateOptions, { value: paddedEndDate })?.label || paddedEndDate;

  formattedInvoiceDate = formatMessage(invoiceDateFormat, {
    year,
    month,
    startDate,
    endDate,
    yearLabel,
    startYearLabel: yearLabel,
    endYearLabel,
    monthLabel,
    startMonthLabel: monthLabel,
    endMonthLabel,
    startDateLabel,
    endDateLabel
  });

  return formattedInvoiceDate;
};

export const formatDisplayInvoiceDate = ({
  unix,
  format = "[{first}] D MMM YYYY",
  firstDayPrefix = "1 -",
  locale = {}
}) => {
  let formattedInvoiceDate = "";
  let unixCopy = unix;
  let formattedDate = "";

  if (!unixCopy) return formattedInvoiceDate;
  if (unixCopy.toString().length === 13) unixCopy = Math.floor(unixCopy / 1000);

  const date = moment
    .unix(unixCopy)
    .subtract(1, "days")
    .endOf("month");

  if (!isEmpty(locale?.month)) {
    const month = date.month();
    const localizedMonth = locale?.month?.[month - 1]?.label;

    if (localizedMonth) {
      // exclude formatting month by moment js
      const updatedFormat = format.replace(/M{2,3}(?=\s)/gm, "[{$&}]");
      // replace month format wild card using localized month
      formattedDate = date
        .format(updatedFormat)
        .replace(/{M{2,3}}/, localizedMonth);
    } else {
      formattedDate = date.format(format);
    }
  } else {
    formattedDate = date.format(format);
  }

  if (formattedDate === "Invalid date") return formattedDate;

  formattedInvoiceDate = formattedDate.replace("{first}", firstDayPrefix); //eg. 1 - 30 Nov 2020
  return formattedInvoiceDate;
};

export const getDeliverySlots = (items, maxCounter, condition) => {
  let res = reduce(
    items,
    (accumulator, item) => {
      const { items, counter } = accumulator;

      if (!isEmpty(item) && condition(item) && counter < maxCounter) {
        return {
          items: items.concat(item),
          counter: counter + 1
        };
      } else {
        return accumulator;
      }
    },
    { items: [], counter: 0 }
  );

  return res.items;
};

export const formatMessage = (template = "", values = {}) => {
  let message = template;
  each(values, (value, key) => {
    message = message.replace(`{${key}}`, value);
  });
  return message;
};

export const generateSubpathComponents = (components, subcomponents) =>
  map(components, component => {
    const subcomponent = find(subcomponents, ({ name, subname }) =>
      subname
        ? subname === get(component, "subname") &&
          name === get(component, "name")
        : name === get(component, "name")
    );
    return subcomponent ? { ...component, ...subcomponent } : component;
  });

export const generateSubpathWorkflow = (
  workflow = {},
  subpath = {},
  props = {}
) => {
  let subWorkflow = cloneDeep(subpath);
  let subpathWorkflow = {};
  const canShowSubPath = safeEval(get, {}, subWorkflow.condition, true, props);
  if (!canShowSubPath) {
    return subpathWorkflow;
  }
  if (workflow.path && subWorkflow.path) {
    subWorkflow.path = workflow.path + subWorkflow.path;
    const subcomponents = cloneDeep(subWorkflow.subcomponents);
    delete subWorkflow.subcomponents;
    subpathWorkflow = { ...workflow, ...subWorkflow };
    delete subpathWorkflow.subpaths;
    subpathWorkflow.components = generateSubpathComponents(
      subpathWorkflow.components,
      subcomponents
    );
  }

  return subpathWorkflow;
};

export const generateWorkflowForSubpaths = (workflows, props) => {
  const generatedWorkflows = [];
  each(workflows, workflow => {
    generatedWorkflows.push(workflow);
    if (!isEmpty(workflow.subpaths)) {
      each(workflow.subpaths, subpath => {
        const subpathWorkflow = generateSubpathWorkflow(
          workflow,
          subpath,
          props
        );
        if (!isEmpty(subpathWorkflow)) {
          generatedWorkflows.push(subpathWorkflow);
        }
      });
    }
  });

  return generatedWorkflows;
};

export const constructDeliverySlotDates = (slots, locale, currencyFormat) => {
  const mappedSlots = map(slots, slot => {
    const dateLabel = constructLocalizedDeliverySlotLabel(slot.date, locale);
    const endDateLabel = constructLocalizedDeliverySlotLabel(
      slot.range_end_date,
      locale
    );
    const labels = [dateLabel, endDateLabel];
    return {
      label: compactJoin(labels, " - "),
      description: slot.display_time,
      value: slot.date_time,
      slotId: slot.id,
      deliverySlot: slot.courier_slot_name,
      date: slot.date_string || head(split(slot.date, "T")),
      deliveryDate: slot.date_time.split(" ")[0],
      endDate: head(split(slot.range_end_date, "T")),
      time: slot.display_time,
      cost: slot.cost,
      special: slot.special,
      formattedCost: formatCurrency(slot.cost, currencyFormat)
    };
  });

  return sortBy(mappedSlots, "date");
};

export const constructFreeDeliverySlots = slots =>
  map(slots, slot => ({
    label: slot.display_time,
    value: slot.date_time,
    slotId: slot.id,
    cost: slot.cost,
    deliverySlot: slot.courier_slot_name,
    startTime: get(slot, "startTime"),
    endTime: get(slot, "endTime")
  }));

export const constructSpecialDeliverySlots = (slots, currencyFormat) =>
  map(slots, slot => ({
    label: slot.display_time,
    value: slot.date_time,
    slotId: slot.id,
    cost: slot.cost,
    formattedCost: formatCurrency(slot.cost, currencyFormat),
    deliverySlot: slot.courier_slot_name,
    startTime: get(slot, "startTime"),
    endTime: get(slot, "endTime"),
    currency: get(slot, "currency")
  }));

export const constructPostOfficeRegions = regions =>
  map(regions, region => ({
    label: region.name,
    value: region.id
  }));

export const constructTerminationReasons = reasons =>
  map(reasons, reason => ({
    label: reason.title,
    value: reason.title,
    winbackId: reason.winback_id
  }));

export const constructTerminationDates = dates =>
  map(dates, ({ date }) => ({
    label: moment(date).format("ddd, DD MMM YYYY"),
    value: date
  }));

export const constructDocTypes = types => {
  const docTypes = [];
  forEach(types, (item, key) => {
    if (item && item.title && item.enable) {
      docTypes.push({
        label: item.title,
        value: key,
        display_sequence: item.display_sequence
      });
    }
  });
  return orderBy(docTypes, ["display_sequence"], ["asc"]);
};

export const specialDeliveryCost = (cost, format) =>
  `Express Delivery: ${formatCurrency(cost, format, true)}`;

export const getDeliverySlotsForDate = (slots, date) =>
  filter(slots, slot => {
    return includes(slot.date, date) || slot.date_string === date;
  });

export const getFreeDeliverySlots = slots =>
  constructFreeDeliverySlots(filter(slots, slot => slot.cost <= 0));

export const getSpecialDeliverySlots = slots =>
  constructSpecialDeliverySlots(filter(slots, slot => slot.cost > 0));

export const getScheduleDeliveryDetailsForSubmit = state => {
  const formValues = get(state, "form.ScheduleDeliveryForm.values", {});
  const {
    alternate_number,
    delivery_zip_code,
    delivery_slot_full_data,
    post_office_id,
    delivery_street_name,
    delivery_building_name,
    delivery_hse_blk_tower,
    delivery_floor_no,
    delivery_unit_no,
    delivery_method,
    delivery_slot_id,
    order_type,
    delivery_type,
    token
  } = formValues;

  const street_building_name = delivery_building_name
    ? `${delivery_street_name}, ${delivery_building_name}`
    : delivery_street_name;

  const payload = {
    order_type,
    delivery_type,
    token,
    alternate_number,
    delivery_method: get(delivery_method, "value"),
    delivery_date: delivery_slot_full_data
      ? head(delivery_slot_full_data.split(" "))
      : null,
    fail_reason: "",
    hse_blk_tower: delivery_hse_blk_tower,
    post_office_id: post_office_id,
    slot_id: delivery_slot_id,
    street_building_name,
    floor_no: delivery_floor_no,
    unit_no: delivery_unit_no,
    zip_code: delivery_zip_code
  };

  return payload;
};

export const safeEval = (
  get,
  formValues,
  condition,
  defaultValue,
  props,
  changedValue
) => {
  let result = defaultValue || condition;

  if (condition) {
    try {
      // eslint-disable-next-line
      result = eval(condition);
    } catch (_) {
      result = defaultValue || condition;
    }
  }
  return result;
};

export const customEval = (label, props) => {
  let labelData = label;
  try {
    if (includes(label, "props")) {
      labelData = eval(label);
    }
  } catch (error) {
    labelData = label;
  }
  return labelData;
};

export const evalProp = (props, condition, defaultValue) => {
  let result = defaultValue || condition;
  if (condition) {
    try {
      // eslint-disable-next-line
      result = eval(condition);
    } catch (_) {
      result = defaultValue || condition;
    }
  }
  return result;
};

export const constructPortInNumberValidation = (locale, portinDetails) => {
  const { message, failure, loading, data } = portinDetails || {};
  let { valid } = data || {};
  const inlineMessage = isEmpty(data)
    ? !isEmpty(failure) && failure?.errorCode
      ? get(locale, "failure.errorCode", failure?.description) ||
        "Number or Donor is Invalid ✘"
      : ""
    : valid
    ? "Nice ✔"
    : get(locale, "failure.errorCode", failure?.description) ||
      "Number or Donor is Invalid ✘";

  if (!isEmpty(failure) && failure?.errorCode) {
    valid = false;
  }
  return {
    valid,
    loading,
    message,
    inlineMessage,
    enablebutton: isEmpty(portinDetails) ? true : valid
  };
};

export const constructPostalCodeValidation = postalCodeValidation => {
  const result = {};
  forEach(postalCodeValidation, (value, key) => {
    const { data = {}, loading } = value;
    const { status: valid, message } = data;
    const inlineMessage = "";
    result[key] = {
      valid,
      loading,
      message,
      inlineMessage
    };
  });
  return result;
};

export const constructPostOfficeDeliverySlots = (
  slots,
  delivery_info_working_hours
) =>
  map(slots, slot => {
    const {
      id,
      name,
      address,
      formatted_address,
      working_hours,
      instant_pickup_start_date_time,
      delivery_slots,
      map_image
    } = slot;

    const monWorkingHours = get(working_hours, [1]);
    const satWorkingHours = get(working_hours, [6]);
    const sunWorkingHours = get(working_hours, [0]);
    const formattedWorkingHours = formatMessage(delivery_info_working_hours, {
      monWorkingHours,
      satWorkingHours,
      sunWorkingHours
    });
    return {
      id,
      name,
      address,
      fullAddress: formatted_address,
      workingHours: formattedWorkingHours,
      pickUpDateTime: instant_pickup_start_date_time,
      deliverySlot: delivery_slots[0],
      delivery_slots,
      mapImage: map_image
    };
  });

export const gotoUrl = (
  url,
  preserveQuery,
  queryOverride = {},
  reload,
  resetQueryParams,
  newUrl
) => {
  let targetUrl = url;
  const queryParams = preserveQuery
    ? queryString.parse(window.location.search)
    : {};
  const query = {
    ...queryParams,
    relaunch: null,
    ...queryOverride
  };
  targetUrl = queryString.stringifyUrl({ url, query }, { skipNull: true });

  //remove the exsisting  query params and add new query paramas to url
  if (resetQueryParams) {
    targetUrl = queryString.stringifyUrl(
      { url, query: resetQueryParams },
      { skipNull: true }
    );
  }
  console.log("Going to Url => ", targetUrl);
  const currentUrl = `${window.location.pathname}${window.location.search}`;
  if (
    targetUrl &&
    targetUrl !== "undefined" &&
    (targetUrl !== currentUrl || reload)
  ) {
    if (includes(targetUrl, "://")) {
      setTimeout(() => {
        window.location = targetUrl;
      }, 0);
    }
    //subcomponents redirect url
    else if (newUrl) {
      setTimeout(() => {
        window.location = `${window.location.origin}${targetUrl}`;
      }, 0);
    } else {
      history.push(targetUrl);
      if (reload) {
        setTimeout(() => {
          window.location.reload();
        }, 0);
      }
    }
  }
};

export const goBack = () => history.go(-1);

export const getReferralCodeBenefitsForPayToday = (
  referralCodeBenefits,
  currencyFormat
) =>
  map(
    filter(referralCodeBenefits, benefit =>
      includes(ONE_TIME_DISCOUNT_TYPES, benefit.type)
    ),
    benefit => {
      const value = -(get(benefit, "product.price.value", 0) / 100);
      const price =
        value === 0 ? null : formatCurrency(value, currencyFormat, true);

      return {
        label: benefit.title,
        price,
        value,
        type: "benefit"
      };
    }
  );

export const getReferralCodeBenefitsForPayMonthly = (
  referralCodeBenefits,
  currencyFormat
) =>
  map(
    filter(
      referralCodeBenefits,
      benefit => !includes(ONE_TIME_DISCOUNT_TYPES, benefit.type)
    ),
    benefit => {
      const negativeValue =
        benefit.type === TELCO_WAIVER_TYPES.TELCO_BILL_WAIVER;

      const priceValue = get(benefit, "product.price.value", 0) / 100;
      const value =
        priceValue !== 0 && negativeValue ? -Math.abs(priceValue) : priceValue;
      const price =
        value === 0 ? null : formatCurrency(value, currencyFormat, true);
      const data =
        benefit.type === TELCO_BENEFIT_TYPES.TELCO_DATA
          ? kbToGB(get(benefit, "product.kb"))
          : undefined;

      return {
        label: benefit.title,
        price,
        value,
        type: "benefit",
        data
      };
    }
  );

export const isWebView = () => {
  return localStorage.getItem("webview") === "1";
};

export const isRevisit = () => {
  return localStorage.getItem("revisit") === "1";
};

export const constructVerifyIdentityParams = payload => {
  const docType = get(payload, "doc_type.value");
  const nric = get(payload, "nric");
  const dobYear = get(payload, "dobYear.value", "");
  const dobMonth = get(payload, "dobMonth.value", "");
  const dobDay = get(payload, "dobDay.value", "");

  const verificationParams = {
    firstName: get(payload, "first_name"),
    middleName: get(payload, "middle_name"),
    lastName: get(payload, "last_name"),
    email: get(payload, "email"),
    dob: `${dobYear}-${dobMonth}-${dobDay}`
  };

  // HACKS, sorry, in a rush
  if (docType === "au_passport") {
    verificationParams.passportDetails = true;
    verificationParams.countryCode = "AUS";
    verificationParams.passportNumber = nric;
  }

  if (docType === "international_passport") {
    verificationParams.passportDetails = true;
    verificationParams.countryCode = get(payload, "country_of_issue.value", "");
    verificationParams.passportNumber = nric;
  }

  if (docType === "driving_licence") {
    verificationParams.drivingLicence = true;
    verificationParams.stateCode = get(payload, "state_of_issue.value", "");
    verificationParams.licenceNumber = nric;
  }

  return verificationParams;
};

export const handleOnLoadAction = props => {
  const currentWorkflowPage = find(
    props.workflow,
    page => page.path === window.location.pathname
  );
  const onLoadAction =
    get(currentWorkflowPage, "onload") || get(currentWorkflowPage, "onLoad");
  const onLoadActionParams = get(
    currentWorkflowPage,
    "onLoadParams",
    get(currentWorkflowPage, "onloadParams", {})
  );
  const onLoadActionHandler = onLoadAction && get(props, onLoadAction);
  isFunction(onLoadActionHandler) &&
    onLoadActionHandler({ ...props, ...onLoadActionParams });
};

export const getOnSubmitActionHandler = props => {
  const currentWorkflowPage = find(
    props.workflow,
    page => page.path === window.location.pathname
  );
  const onSubmitWorkflow =
    get(currentWorkflowPage, "onsubmit") ||
    get(currentWorkflowPage, "onSubmit");
  const onSubmitAction = get(props, "onSubmitOverride") || onSubmitWorkflow;
  const onSubmitActionHandler = onSubmitAction && get(props, onSubmitAction);
  return onSubmitActionHandler;
};

export const constructOnChangeHandler = props => {
  return changedValue => {
    const on_change = props.on_change;
    on_change &&
      safeEval(get, props.formValues, on_change, false, props, changedValue);
  };
};

// convert kib to gib and rounding up to nearest 1 decimal place
export const kbToGB = kb =>
  kb ? convertToOneDecimalPlace(Number(kb) / 1048576) : 0;

export const convertToOneDecimalPlace = val => Math.round(val * 10) / 10;

export const formatAddonsForPayMonthly = (
  addons = [],
  selectedAddons = {},
  currencyFormat,
  basicTax = 0
) =>
  map(addons, addon => {
    const precision = get(currencyFormat, "precision", 2);
    const taxPercent = Number(get(addon, "tax_percentage", basicTax));
    // const price =
    //   Number(
    //     get(addon, "attributes", []).find(
    //       attribute => attribute.name === "price"
    //     )?.value
    //   ) ||
    //   addon.value ||
    //   0;

    const strikeOffPrice = get(addon, "specs.strikeOffPrice", null);
    const price = get(addon, "price");
    const price_without_tax = ceil(price / (1 + taxPercent / 100), precision);
    const finalPrice = price;
    const oldPrice = null;
    const isBundleDiscounted = () => {
      return (
        addon?.productCode === "product_bundle" &&
        addon?.discountedPrice < addon?.price
      );
    };

    return {
      id: addon.id || addon.sku,
      banners: addon?.urls?.bannerImageUrl,
      label: addon.title || addon.name,
      productCode: addon.productCode,
      name: addon.name,
      features: addon.features,
      attributes: addon.attributes,
      data: addon.kb ? kbToGB(addon.kb) : 0,
      description: addon.description_short || addon.description_full,
      value: isBundleDiscounted()
        ? get(addon, "discountedPrice")
        : get(addon, "price"),
      discountedPrice: get(addon, "discountedPrice"),
      benefits: get(addon, "benefits"),
      oldPrice: oldPrice ? Math.round(oldPrice) : null,
      originalPrice: price,
      product_link: addon.product_link,
      value_without_tax: price_without_tax,
      loyaltyPoints: addon?.loyaltyPoints,
      displayPrice: finalPrice,
      price: formatCurrency(finalPrice, currencyFormat, false),
      strikeOffPrice: formatCurrency(strikeOffPrice, currencyFormat, false),
      price_without_tax: formatCurrency(
        price_without_tax,
        currencyFormat,
        true
      ),
      highlightText: get(addon, "specs.highlightText", null),
      priority: get(addon, "priority", null),
      selected: get(selectedAddons, addon.id || addon.sku, false),
      recurrence:
        get(addon, "attributes", []).find(
          attribute => attribute.name === "recurrent"
        )?.value !== "false"
          ? "mo"
          : "pack"
    };
  });

const zendeskOptions = {
  rootElementId: "zendesk-widget",
  accountKey: window.ZENDESK_CHAT_ACCOUNT_KEY || ZENDESK_CHAT_ACCOUNT_KEY,
  theme: "normal",
  hideMinimizeButton: false,
  hideChatButton: true,
  // userId: urlParam("userid"),
  userId: urlParam("username"),
  disableEmail: true,
  anonymous: true,
  hideOfflineForm: true,
  hideOnInit: false,
  offlineMessage:
    "Our Customer Happiness experts are currently unavailable. Please drop us an email at happiness@onic.pk and our dedicated team will respond to your inquiry as soon as possible within 1 working day. Thank you!",
  redact: true
};

export const activateZendeskWidget = zEIdentify => {
  const standaloneChatUrl = window.STANDALONE_ZENDESK_CHAT_URL;
  if (standaloneChatUrl) {
    const finalUrl = isWebview()
      ? standaloneChatUrl.replace("https", MOBILE_APP_BROWSER_PROTOCOL)
      : standaloneChatUrl;
    window.open(finalUrl);
  } else {
    // If required to prefil the zendesk form pass in the zEIdentify object
    if (zEIdentify && window.zE && window.zEmbed.widget !== "messenger") {
      const { name = "", email = "", phone = "" } = zEIdentify || {};
      if (get(window, "zE.identify")) {
        window.zE.identify(zEIdentify);
      }
      if (name || email || phone) {
        window.zE("webWidget", "prefill", {
          name: {
            value: name,
            readOnly: !!name // readOnly if value is prefilled
          },
          email: {
            value: email,
            readOnly: !!email // readOnly if value is prefilled
          },
          phone: {
            value: phone,
            readOnly: !!phone // readOnly if value is prefilled
          }
        });
      }
    }
    if (window.YellowMessengerPlugin) {
      window.YellowMessengerPlugin.show();
      window.YellowMessengerPlugin.openBot();
      localStorage.setItem("yellow-messenger-chat-open", true);
    } else if (window.activateZendesk) {
      zendeskOptions.userId = zEIdentify?.name;
      const options = {
        ...zendeskOptions
      };
      window.activateZendesk(options);
    } else if (window.zEmbed.widget === "messenger") {
      window.zE && window.zE("messenger", "open");
    } else {
      if (window.Intercom) {
        window.Intercom("show");
      }
    }
  }
};

export const calTotalData = (plan, locale) => {
  let totalDataValueGB = 0;
  let isUnlimited = false;
  if (!isEmpty(plan.customisedProductVariants)) {
    // eslint-disable-next-line no-unused-expressions
    for (const variant of plan.customisedProductVariants) {
      const dataAttribute = variant.attributes.find(
        attr => attr.name === "data"
      );
      if (dataAttribute) {
        if (
          dataAttribute?.value?.toLowerCase() === DATA_BUNDLE.unlimitedLower
        ) {
          isUnlimited = true;
          break;
        } else {
          let dataValue = parseFloat(dataAttribute.value);
          if (!isNaN(dataValue)) {
            if (dataAttribute.unit.toLowerCase() === DATA_VALUE_TYPE.MB) {
              dataValue /= 1024;
            }
            totalDataValueGB += dataValue;
          }
        }
      }
    }
  }

  return isUnlimited
    ? formatMessage(get(locale, "unlimitedData", DATA_BUNDLE.UnlimitedCamel))
    : formatGBValue(totalDataValueGB);
};

export const formatGBValue = totalDataValueGB => {
  let formattedTotalDataValue = "";
  if (totalDataValueGB % 1 === 0) {
    formattedTotalDataValue = totalDataValueGB.toString();
  } else {
    formattedTotalDataValue = totalDataValueGB.toFixed(1);
  }
  return isEmpty(formattedTotalDataValue) ? "" : formattedTotalDataValue + "GB";
};

export const activateZendeskApp = () => {
  if (window.activateZendesk) {
    const options = {
      ...zendeskOptions,
      rootElementId: "zendesk-app",
      theme: "standalone",
      hideMinimizeButton: true,
      hideChatButton: true
    };
    window.activateZendesk(options);
  }
};

export const formatPathUrl = path => {
  return path.includes("/web/")
    ? path
        .replace("/web/", "")
        .split("/")
        .join("-")
        .replace(/^-/, "")
    : path
        .split("/")
        .join("-")
        .replace(/^-/, "");
};

export const processPlugin = (plugin, pluginData) => {
  const js = get(plugin, "js_libs") || [];
  const css = get(plugin, "css_libs") || [];
  let script = get(plugin, "escaped_script") || "";
  if (script) {
    script = script.replace(/\\\//g, "/");
    forEach(pluginData, (value, key) => {
      script = script.replace(`~${key}~`, value);
    });
  }
  let noScript = get(plugin, "noscript") || "";
  return { js, css, script, noScript };
};

export const processPlugins = (plugins = {}, pluginData = {}) => {
  const jsLibs = [];
  const cssLibs = [];
  const escapedScripts = [];
  const noScripts = [];

  forEach(plugins, (plugin, key) => {
    if (plugin.enabled) {
      const { js, css, script, noScript } = processPlugin(plugin, pluginData);
      jsLibs.push(...js);
      cssLibs.push(...css);
      script && escapedScripts.push(script);
      noScript && noScripts.push(noScript);
    } else {
      window[`${key}Disabled`] = true;
    }
  });

  const escapedScript = escapedScripts.join("\n");

  return { jsLibs, cssLibs, escapedScript, noScripts };
};

export const isIccIdValid = (iccIdInUrl, generic, iccIdField, iccIdRegex) => {
  const prefix = get(generic, "icc_id.prefix", "");
  const regex = iccIdRegex || get(generic, "icc_id.validation_regex", "");
  const iccIdFieldValid = iccIdField && RegExp(regex).test(iccIdField);
  const iccIdInUrlValid =
    iccIdInUrl &&
    iccIdInUrl.startsWith(prefix) &&
    RegExp(regex).test(iccIdInUrl.replace(prefix, ""));
  return iccIdInUrlValid || iccIdFieldValid;
};

export const handleRouteLoading = setRouteLoading => {
  setNewRelicAttribute("deviceId", getDeviceId());
  setNewRelicAttribute("locale", getLocaleOrDefault());
  setNewRelicAttribute("webview", isWebview());
  setNewRelicAttribute("native", isNative());
  setNewRelicAttribute("reset", urlParam("reset"));
  setNewRelicAttribute("pathname", window?.location?.pathname);
  updatePageLoadTime(new Date());
  if ((!getDeviceId() || isActivationSuccess()) && isWorkflowChannel()) {
    setRouteLoading(true);
    resetApp(isActivationSuccess());
    return true;
  } else {
    setRouteLoading(false);
    return false;
  }
};

export const isWorkflowChannel = () =>
  WORKFLOW_CHANNELS.includes(getChannelFromUrl());

export const resetApp = goHome => {
  const queryParams = {
    reset: true,
    locale: getItem("locale"),
    webview: getWebview()
  };
  !goHome
    ? gotoUrl(window.location.pathname, true, queryParams, true)
    : isWebview()
    ? gotoUrl(paths.DASHBOARD)
    : gotoUrl(getLandingPage(), true, queryParams, true);
};

export const resetSession = () => {
  const queryParams = {
    reset: true,
    locale: getItem("locale"), //getLocale(),
    webview: getWebview()
  };
  const landingPage = isWorkflowChannel()
    ? getLandingPage()
    : window.location.pathname;
  gotoUrl(landingPage, true, queryParams, true);
};

export const getAuthorizationHeader = () => {
  const timeStamp = new Date().getTime();
  const hashHexDigest = Sha256(ECOM_API_KEY + timeStamp).toString(Hex);
  const token = hashHexDigest.toUpperCase();
  return {
    token,
    timeStamp
  };
};

export const isAlphaFlow = () => {
  const path = window.location.pathname;
  const alphaFlows = [
    ...WORKFLOW_CHANNELS,
    "shop",
    "infinite",
    "manage",
    "self_act_del",
    "schedule_delivery",
    "surveys",
    "identity",
    "plan",
    "profile",
    "wirecard",
    "verify-identity",
    "orders",
    "partners",
    "ekyc_verify"
  ];

  const PUBLIC_PATHS = map(publicPaths, path => path);
  const alphaPaths = [
    paths.LANDING_PAGE,
    paths.PING,
    paths.ERROR_404,
    paths.ERROR_500,
    paths.MAINTENANCE,
    paths.DASHBOARD,
    paths.LOGGED_OUT,
    paths.WEBLOGIN,
    paths.CLOSEWEBVIEW,
    paths.UPDATE_CARD_SUCCESS,
    paths.PROFILE_UPDATE_EMAIL_SUCESS,
    paths.SCANNER,
    paths.ZENDESK,
    paths.IDENTITY_VERIFICATION,
    paths.PAYMENT_RETURN_V3,
    paths.OUTSTANDING_BILLS,
    paths.DIRECT_LINK_EXPIRED,
    paths.PLAN_SELECTION,
    paths.PROFILE,
    paths.PAYMENT_AMAZON,
    paths.OUTSTANDING_BILLS,
    paths.DIRECT_LINK_EXPIRED,
    paths.OUTSTANDING_BILLS_PAYMENT_STATUS,
    paths.OUTSTANDING_BILLS_PAYMENT_STATUS_SUCCESS,
    paths.OUTSTANDING_BILLS_PAYMENT_STATUS_FAILURE,
    paths.OUTSTANDING_BILLS_PAYMENT_STATUS_IN_PROGRESS,
    paths.OUTSTANDING_BILL_PAYMENT,
    paths.PAYMENT_VERIFY,
    ...PUBLIC_PATHS
  ];

  if (alphaPaths.includes(path)) return true;
  for (const flow of alphaFlows) {
    if (path.match(`/${flow}/`)) {
      return true;
    }
  }
};

export const getDateDetails = date => {
  const dateValue = head(split(date, "T"));
  const dateMoment = moment(dateValue);
  const day = dateMoment.format("DD");
  const month = dateMoment.format("MM");
  const year = dateMoment.format("YYYY");
  const dayOfWeek = dateMoment.format("ddd");
  const currentDate = moment().format("YYYY-MM-DD");
  const dayDiff = dateMoment.diff(currentDate, "days");
  const today = dayDiff === 0;
  const tomorrow = dayDiff === 1;
  return [day, month, year, dayOfWeek, today, tomorrow];
};

export const constructLocalizedDeliverySlotLabel = (dateTime, locale) => {
  if (!dateTime) return "";
  const [date, month, year, dayofWeek, today, tomorrow] = getDateDetails(
    dateTime
  );

  const localizedDayOfWeek = get(
    locale,
    `day_short_${dayofWeek.toLocaleLowerCase()}`,
    ""
  );
  const localizedMonth = get(locale, `month_long_${month}`, "");

  const localizedDate = get(locale, `date_${date}`, "");

  const prefix = today
    ? get(locale, "today", "")
    : tomorrow
    ? get(locale, "tomorrow", "")
    : "";

  const deliverySlotLabel = get(
    locale,
    "delivery_slot_label",
    "{year}/{month}/{date} ({day})"
  );

  const localizedLabel = formatMessage(deliverySlotLabel, {
    date: localizedDate,
    month: localizedMonth,
    year: year,
    day: localizedDayOfWeek
  });

  return prefix ? `${prefix}, ${localizedLabel}` : localizedLabel;
};

export const constructLocalizedDeliverySlotDetails = (
  deliverySlotFullData = "",
  locale
) => {
  const slotData = split(deliverySlotFullData, " ");
  const slotDate = get(slotData, [0], "");
  const deliveryTime = get(slotData, [1], "");
  const deliveryDate = constructLocalizedDeliverySlotLabel(slotDate, locale);
  return { deliveryDate, deliveryTime };
};

export const addressParams = (info, prefix, isCamelCase) => {
  if (isEmpty(info)) return {};
  let unitNo = get(info, `${prefix}_unit_no`) || "";
  let hseBlkTower = get(info, `${prefix}_hse_blk_tower`);
  let streetName = get(info, `${prefix}_street_name`);
  let zipCode = get(info, `${prefix}_zip_code`) || "";
  let firstName = get(info, "first_name");
  let LastName = get(info, "last_name");
  let middleName = get(info, "middle_name");

  let addressLine1 = get(info, `${prefix}_address_line_1`) || streetName || "";
  let addressLine2 = get(info, `${prefix}_address_line_2`) || unitNo || "";
  let addressLine3 = get(info, `${prefix}_address_line_3`) || "";
  let specialInstructions = get(info, `${prefix}_instructions`);
  let landMark = get(info, `${prefix}_landmark`);
  // let tempprovince =
  // getValueOrLabel(get(info, `${prefix}_province`)) ||
  // getValueOrLabel(get(info, `${prefix}_province.value`)) ||
  // ""
  // let tempState= getValueOrLabel(get(info, `${prefix}_state`)) || ""

  // [OG-6277] TODO - move this AU specific logic to config.
  if (lower(COUNTRY) === "au") {
    // [OG-5860] Prefix 'Unit' if not already present in unit_no
    unitNo =
      unitNo && !startsWith(lower(unitNo), "unit") ? `Unit ${unitNo}` : unitNo;
    // [OG-5860] join the hseBlkTower(streetNo) as part of street name
    streetName = compactJoin([hseBlkTower, streetName], " ");
    hseBlkTower = "";
  }

  //For pop station, use the postal code OF THE POP STATION. Not the postal code field that user type in.
  if (prefix === DELIVERY_METHOD_TYPE.POP_STATION) {
    zipCode = get(info, "pop_station_outlet_full_data.postal_code");
  }

  const buildingName = get(info, `${prefix}_building_name`) || "";
  const villageName = getValueOrLabel(get(info, `${prefix}_village`));
  const streetBuildingName =
    compactJoin([streetName, buildingName, villageName], ", ") || "";
  let addressInfo = {
    state: getValueOrLabel(get(info, `${prefix}_state`)) || "",
    city:
      getValueOrLabel(get(info, `${prefix}_city`)) ||
      getValueOrLabel(get(info, `${prefix}_city.value`)) ||
      "",
    district: getValueOrLabel(get(info, `${prefix}_district`)) || "",
    village: getValueOrLabel(get(info, `${prefix}_village`)) || "",
    country:
      get(info, `${prefix}_country.value`) ||
      get(info, `${prefix}_country`) ||
      "Pakistan" ||
      "",
    province:
      getValueOrLabel(get(info, `${prefix}_province`)) ||
      getValueOrLabel(get(info, `${prefix}_province.value`)) ||
      "",
    area:
      getValueOrLabel(get(info, `${prefix}_area`)) ||
      getValueOrLabel(get(info, `${prefix}_area.value`)) ||
      "",
    prefecture: getValueOrLabel(get(info, `${prefix}_state`)) || "",
    landmark: landMark
  };

  const floorNo = get(info, `${prefix}_floor_no`) || "";
  const address_unitNo = unitNo || "";
  if (isCamelCase) {
    addressInfo = {
      ...addressInfo,
      unitNo: address_unitNo,
      floorNo: floorNo,
      streetBuildingName: streetBuildingName,
      buildingName: buildingName,
      hseBlkTower: hseBlkTower || "",
      addressLine1: addressLine1,
      addressLine2: addressLine2,
      addressLine3: addressLine3,
      postalCode: zipCode,
      firstName,
      LastName,
      middleName,
      specialInstructions
    };
  } else {
    addressInfo = {
      ...addressInfo,
      zip_code: zipCode,
      unit_no: address_unitNo,
      floor_no: floorNo,
      street_name: streetName || "",
      street_building_name: streetBuildingName,
      building_name: buildingName,
      hse_blk_tower: hseBlkTower || "",
      address_line_1: addressLine1,
      address_line_2: addressLine2,
      address_line_3: addressLine3 || "",
      special_instrutions: specialInstructions
    };
  }
  return addressInfo;
};

export const deliverySlotParams = (
  deliveryInfo,
  personalDetails = {},
  isCamelCase = false
) => {
  const info = isEmpty(deliveryInfo) ? personalDetails : deliveryInfo;
  let delivery_slot = {};
  let deliverySlot = {};
  const slotDate = head(split(get(info, "delivery_slot_full_data"), " "));
  const delivery_date = moment(get(info, "delivery_date") || slotDate).format(
    "DD-MM-YYYY"
  );
  const delivery_end_date = get(info, "delivery_end_date") || delivery_date;
  const post_office_id =
    get(info, "delivery_method.action") === DELIVERY_METHOD_TYPE.INSTANT_PICK_UP
      ? get(info, "post_office_id")
      : null;
  if (!isNil(info.delivery_slot_id)) {
    delivery_slot = {
      delivery_method: get(info, "delivery_method.value"),
      slot_id: get(info, "delivery_slot_id"),
      delivery_date,
      delivery_end_date,
      delivery_slot: get(info, "delivery_slot"),
      delivery_slot_fee: get(info, "delivery_slot_fee") || 0,
      delivery_slot_full_data: get(info, "delivery_slot_full_data"),
      ...(post_office_id && { post_office_id })
    };
    deliverySlot = {
      slotId: get(info, "delivery_slot_id"),
      date: delivery_date,
      courierName: get(info, "delivery_slot")
    };
  }
  delivery_slot = isCamelCase ? deliverySlot : delivery_slot;
  return { delivery_slot };
};

export const eLOAParams = formValues => {
  const { dob, doi_dob, rName, rEmail, rNric } = formValues;
  return {
    filledAuthoriationForm: "true",
    doi: doi_dob || dob,
    is11BHolder: get(formValues, "is11BHolder", false),
    rName,
    rEmail,
    rNric
  };
};

export const identityELOAParams = formValues => {
  return {
    loa: {
      order_id: get(formValues, "order_id", ""),
      ...eLOAParams(formValues)
    }
  };
};

export const popStationParams = formValues => {
  const {
    pop_station_slot,
    pop_station_slot_id,
    building_name,
    pop_station_zip_code,
    pop_station_slot_full_data,
    pop_station_hse_blk_tower,
    pop_station_outlet_full_data
  } = formValues;
  return {
    delivery_method: get(DELIVERY_METHOD_TYPE, "POP_STATION", "pop_station"),
    delivery_slot: pop_station_slot_full_data,
    delivery_date: pop_station_slot_full_data?.split(" ")[0],
    hse_blk_tower: pop_station_hse_blk_tower,
    popstation_outlet_id: get(pop_station_outlet_full_data, "outlet_id"),
    slot_id: pop_station_slot_id,
    slot_name: pop_station_slot,
    street_building_name: building_name,
    unit_no: get(pop_station_outlet_full_data, "unit_number"),
    zip_code: pop_station_zip_code
  };
};

export const userDetailParams = (
  personalDetails,
  deliveryInfo,
  userDetails,
  incompleteOrder = false,
  isCamelCase,
  profileValidations
) => {
  const details = !isEmpty(personalDetails) ? personalDetails : deliveryInfo;
  const isEmptydetails = !isEmpty(details) || !isEmpty(userDetails);
  const firstName = get(details, "first_name", get(details, "full_name", ""));
  const middleName = get(details, "middle_name");
  const lastName = get(details, "last_name");
  const dateofBirth = get(details, "dob");

  let user_detail = {
    ...(get(profileValidations, "contactNumber.enabled") && {
      contactNumber: get(details, "contact_number")
    }),
    ...(get(profileValidations, "email.enabled") && {
      email: get(details, "email") || get(userDetails, "email")
    }),
    ...(get(profileValidations, "nationality.enabled") && {
      nationality: get(details, "nationality.value")
    }),
    ...(get(profileValidations, "CNICExpiryDate.enabled") && {
      identificationExpiryDate: get(
        details,
        "document_identificationNumberExpiryDate"
      )
    }),
    ...(get(profileValidations, "CNICNumber.enabled") && {
      identificationNumber: get(details, "identification_number")
    })
  };
  if (isCamelCase) {
    if (isEmptydetails) {
      userDetails = {
        ...user_detail,
        ...(get(profileValidations, "firstName.enabled") && {
          firstName: firstName
        }),
        ...(get(profileValidations, "middleName.enabled") && {
          middleName: middleName
        }),
        ...(get(profileValidations, "lastName.enabled") && {
          lastName: lastName
        }),
        ...(get(profileValidations, "dob.enabled") && {
          dateOfBirth: dateofBirth
        })
      };
    }
  } else {
    if (isEmptydetails) {
      user_detail = {
        ...user_detail,
        ...(get(profileValidations, "firstName.enabled") && {
          first_name: firstName
        }),
        ...(get(profileValidations, "middleName.enabled") && {
          middle_name: middleName
        }),
        ...(get(profileValidations, "lastName.enabled") && {
          last_name: lastName
        }),
        ...(get(profileValidations, "dob.enabled") && {
          dob: dateofBirth
        }),
        nric: get(details, "nric"),
        country_code: get(details, "country_code"),
        phone_number: get(details, "contact_number")
      };
    }
  }
  return isCamelCase ? { userDetails } : user_detail;
};

export const documentsParams = formValues => {
  let documents = {};
  const primary_id = get(formValues, "nric") || get(formValues, "primary_id");
  const secondary_id = get(formValues, "secondary_id");
  const doc_id =
    get(formValues, "documents.primary.front_image") ||
    get(formValues, "documents.primary.back_image") ||
    get(formValues, "documents.secondary.front_image") ||
    get(formValues, "documents.secondary.back_image");
  const primary_doc_type =
    get(formValues, "doc_type.value") ||
    get(formValues, "primary_doc_type.value") ||
    (get(formValues, "nric") ? "nric" : "");
  const secondary_doc_type = get(formValues, "secondary_doc_type.value");

  let issued_by;
  if (primary_doc_type === "international_passport") {
    issued_by = get(formValues, "country_of_issue.value");
  } else if (primary_doc_type === "driving_licence") {
    issued_by = get(formValues, "state_of_issue.value");
  }

  if (!isEmpty(primary_id)) {
    documents = {
      doc_id,
      details: [
        {
          doc_id,
          doc_type: primary_doc_type,
          category: "primary",
          value: primary_id,
          issued_by
        }
      ]
    };
    if (!isEmpty(secondary_id)) {
      documents.details.push({
        doc_id,
        doc_type: secondary_doc_type,
        category: "secondary",
        value: secondary_id
      });
    }
  }

  return documents;
};

export const deliverDetailParams = (
  deliveryInfo,
  personalDetails,
  isCamelCase
) => {
  // delivery details may come from personal details page
  const info = isEmpty(deliveryInfo) ? personalDetails : deliveryInfo;
  let prefix = "delivery";

  let deliver_detail = {};
  if (!isEmpty(info)) {
    deliver_detail = addressParams(info, prefix, isCamelCase);
    deliver_detail["deliveryNote"] = get(info, "delivery_note");
  }

  return { deliver_detail };
};
export const reschedulePayloadConstruct = (stateProps, ownProps) => {
  const { orderRef = "" } = ownProps;
  const updatedDetails = "deliveryDetailsItems";
  const deliveryMethod = get(
    stateProps,
    `${updatedDetails}.newShipmentMethod`,
    ""
  );
  const deliveryInstructionsVal = get(
    stateProps,
    "formValues.delivery_instructions"
  );
  const isSelfPickUp = deliveryMethod === SHIPMENT_METHOD.SELF_PICKUP;
  const isFailedDelivery =
    get(stateProps, `${updatedDetails}.order.state`) === ORDER_STATUS.DFL;

  const lastDeliveryDetails = get(
    stateProps,
    `${updatedDetails}.lastDeliveryDetails`,
    {}
  );
  const orderReference = orderRef;

  const newAddress = isSelfPickUp
    ? {}
    : get(stateProps, `${updatedDetails}.deliveryAddressDetails`, {});

  const selfPickUpDetails = isSelfPickUp
    ? get(stateProps, `${updatedDetails}.selfPickUpLocation`, {})
    : {};
  const newDeliveryAddress = {
    addressLine1: get(newAddress, "address_line_1"),
    addressLine2: get(newAddress, "address_line_2"),
    addressLine3: get(newAddress, "address_line_3"),
    city: get(newAddress, "city"),
    province: get(newAddress, "province"),
    landmark: get(newAddress, "landmark"),
    area: get(newAddress, "area"),
    country: get(newAddress, "country"),
    state: get(newAddress, "province")
  };

  const newSlotId = get(stateProps, `${updatedDetails}.deliverySlotId`);
  const newSlotDate = get(stateProps, `${updatedDetails}.newDeliveryDate`);
  const lastSlotId = get(lastDeliveryDetails, "last_slot_id");
  const lastSlotDate = get(lastDeliveryDetails, "last_delivery_date");
  const postalCode = isSelfPickUp
    ? get(selfPickUpDetails, "zipcode")
    : get(newAddress, "zip_code");
  const newPickupLocationId = isSelfPickUp
    ? get(stateProps, `${updatedDetails}.selfPickUpLocation.id`)
    : null;
  const lastPickUpLocationId = get(
    lastDeliveryDetails,
    "last_self_pick_up_location_id"
  );
  const deliveryFee = get(
    stateProps,
    `${updatedDetails}.rescheduleDeliveryFee`
  );
  const currency = get(lastDeliveryDetails, "last_slot_fee_structure.currency");

  const isPostpaid = get(stateProps, "deliveryDetailsItems.postpaid");
  const paymentDetails = {
    deliveryFee,
    currency
  };
  if (
    (isPostpaid && isSelfPickUp && isFailedDelivery) ||
    (!isPostpaid && isSelfPickUp)
  ) {
    return {
      orderReference,
      deliveryDetails: {
        deliveryMethod: deliveryMethod,
        deliveryInstruction: deliveryInstructionsVal,
        selfPickupDeliveryDetails: {
          pickupLocationId: newPickupLocationId,
          zipcode: postalCode
        },
        doorstepDeliveryDetails: null
      },
      paymentDetails
    };
  }
  if (
    (isPostpaid && !isSelfPickUp && isFailedDelivery) ||
    (!isPostpaid && !isSelfPickUp)
  ) {
    return {
      orderReference,
      deliveryDetails: {
        deliveryMethod,
        deliveryInstruction: deliveryInstructionsVal,
        selfPickupDeliveryDetails: null,
        doorstepDeliveryDetails: {
          slotId: newSlotId,
          date: newSlotDate,
          zipcode: postalCode,
          ...newDeliveryAddress
        }
      }
      // paymentDetails
    };
  }
  if (!isFailedDelivery) {
    return {
      deliveryMethod,
      orderReference: orderRef,
      postalCode: postalCode,
      price: {
        price: deliveryFee,
        currency
      },
      specialInstructions: "",
      selfPickUpLocationId: newPickupLocationId,
      existingSelfPickUpLocationId: lastPickUpLocationId,
      ...newDeliveryAddress,
      slot: isSelfPickUp
        ? {}
        : {
            slotId: newSlotId,
            date: newSlotDate
              ?.split("-")
              ?.reverse()
              ?.join("-")
          },
      existingSlot: {
        date: lastSlotDate,
        slotId: lastSlotId
      }
    };
  }
};

export const sanitizeDeliveryAddressLabel = (
  addressDetails,
  deliveryAddressLabel
) => {
  let sanitizedLabel = deliveryAddressLabel;

  const fieldRegex = /{[a-zA-Z_0-9]+}/g;
  const matches = deliveryAddressLabel.match(fieldRegex);
  const fields = map(matches, match => trim(match, "{}"));

  let allAddressFieldsEmpty = !isEmpty(fields);

  each(fields, field => {
    const value = get(addressDetails, field);
    if (!value) {
      const regex = new RegExp(`{${field}}[-, ]?`, "g");
      sanitizedLabel = sanitizedLabel.replace(regex, "");
    } else {
      allAddressFieldsEmpty = false;
    }
  });

  return allAddressFieldsEmpty ? "" : trim(sanitizedLabel, "-, <br/>");
};

export const constructLocalizedDeliveryAddress = (
  addressDetails,
  locale,
  label
) => {
  const deliveryAddressLabel = get(
    locale,
    label ?? "delivery_address_label",
    "{zip_code}, {country}, {province}, {city}, {area}, {address_line_1}, {address_line_2}"
    // "{address_line_1} {address_line_2} {province} {city} {area} {zip_code} {country}"
  );

  // Remove fields in the target format if they are empty. ex: {unit_no}, {street_building_name} => {street_building_name}
  // This is to avoid dangling commas if the optional field unit_no is not specified.
  const sanitizedLabel = sanitizeDeliveryAddressLabel(
    addressDetails,
    deliveryAddressLabel
  );

  return formatMessage(sanitizedLabel, addressDetails);
};

export const constructLocalizedBillingAddress = (
  addressDetails,
  locale,
  label = "billing_address_label"
) => {
  const billingAddressLabel = get(
    locale,
    label,
    "{zip_code} {country} {city} {state} {address_line_1} {unit_no}"
  );

  // Remove fields in the target format if they are empty. ex: {unit_no}, {street_building_name} => {street_building_name}
  // This is to avoid dangling commas if the optional field unit_no is not specified.
  const sanitizedLabel = sanitizeDeliveryAddressLabel(
    addressDetails,
    billingAddressLabel
  );

  return formatMessage(sanitizedLabel, addressDetails);
};

export const getValueOrLabel = value => getValueOrField(value, "label");

export const getValueOrField = (value, field) =>
  isPlainObject(value) ? value[field] : value;

export const compactJoin = (values, separator = "") =>
  join(compact(values), separator);

export const calculatePayMonthlyItems = ({
  basicPrice,
  items,
  currencyFormat,
  referralCode,
  addons,
  defaultPlanAddons,
  basicTax = 0,
  phonesForm,
  discount,
  numberType,
  planDetails,
  selectedNumberType,
  selfActivation,
  generic
}) => {
  let currentPrice =
    get(planDetails, "discountedPrice") || get(planDetails, "price");
  let price =
    !isEmpty(discount) &&
    includes(get(discount, "allowed_plans"), get(planDetails, "name")) &&
    ((numberType === "port_in" && isEmpty(selectedNumberType)) ||
      selectedNumberType.isPortIn)
      ? currentPrice - discount.value
      : currentPrice;

  const label =
    !isEmpty(discount) &&
    includes(get(discount, "allowed_plans"), get(planDetails, "name")) &&
    ((numberType === "port_in" && isEmpty(selectedNumberType)) ||
      selectedNumberType.isPortIn)
      ? "port_in_discount"
      : get(planDetails, "name") === "CirclesParent"
      ? "circles_family_base_price"
      : "base_price";

  if (get(selfActivation, "sim_count")) {
    const sim_count = get(selfActivation, "sim_count") || 1;
    const child_sim_count = sim_count - 1;
    const child_sim_cost =
      child_sim_count * get(generic, "family_plan_child_sim.price");
    if (child_sim_count) {
      price = price + child_sim_cost;
    }
  }
  const precision = get(currencyFormat, "precision", 2);
  const price_without_tax = ceil(price / (1 + basicTax / 100), precision);
  const basePrice = {
    label,
    value: price,
    value_without_tax: price_without_tax,
    type: "plan",
    price: formatCurrency(price, currencyFormat),
    price_without_tax: formatCurrency(price_without_tax, currencyFormat),
    features: get(planDetails, "features", [])
  };

  const baseItems = map(items, item => {
    const itemTaxPercent = Number(get(item, "tax_percentage", basicTax));
    const price_without_tax =
      item.value === 0
        ? null
        : formatCurrency(
            item.value / (1 + itemTaxPercent / 100),
            currencyFormat
          );
    const price =
      item.value === 0 ? null : formatCurrency(item.value, currencyFormat);

    return {
      ...item,
      price,
      price_without_tax
    };
  });

  const referralCodeBenefits = getReferralCodeBenefitsForPayMonthly(
    referralCode.benefits,
    currencyFormat
  );

  const selectedAddons = addons.filter(addon => addon.selected);
  const defaultAddons = formatAddonsForPayMonthly(
    defaultPlanAddons,
    currencyFormat,
    basicTax
  );

  const phoneDetails = getPhoneDetailsForPayMonthly(phonesForm, currencyFormat);

  const payMonthlyItems = [
    basePrice,
    ...baseItems,
    ...defaultAddons,
    ...selectedAddons,
    ...referralCodeBenefits,
    ...phoneDetails
  ];

  return payMonthlyItems;
};

export const calculatePayTodayItems = ({
  items,
  currencyFormat,
  referralCode,
  deliveryInfo,
  personalDetails,
  selectedNumber,
  selectedNumberType,
  portInForm,
  page,
  numberFormat,
  locale,
  phonesForm,
  basicTax = 0,
  selfActivationForm,
  preActivationDeliveryAddon,
  deliveryHomeSlotType,
  order,
  connectionDetails
}) => {
  const isPortIn = selectedNumberType.isPortIn;

  const payTodayItems = map(items, item => {
    const itemTaxPercent = Number(get(item, "tax_percentage", basicTax));
    const price_without_tax = formatCurrency(
      item.value || 0 / (1 + itemTaxPercent / 100),
      currencyFormat,
      true
    );
    const price = formatCurrency(item.value || 0, currencyFormat, true);
    return {
      ...item,
      price,
      description: price,
      price_without_tax
    };
  });

  let selectedNumberItem = [];
  if (page !== "PreCheckout") {
    const { number, price, sku } = selectedNumber || {};
    let numberTypeText = getNumberType({ sku, isPortIn });

    const numberTypeSelectedNumber = isPortIn
      ? get(portInForm, "post_paid_number")
      : formatDisplayNumber(number, numberFormat);

    numberTypeText = get(locale, numberTypeText, numberTypeText);
    const numberItem = {
      label: `${numberTypeText}: ${numberTypeSelectedNumber}`,
      type: "number"
    };

    if (!isPortIn && price > 0) {
      numberItem["value"] = price;
      numberItem["price"] = formatCurrency(price, currencyFormat, true);
    }

    selectedNumberItem.push(numberItem);
  }

  const referralCodeBenefits = getReferralCodeBenefitsForPayToday(
    referralCode.benefits,
    currencyFormat
  );

  const deliveryForm = isEmpty(deliveryInfo)
    ? isEmpty(personalDetails)
      ? selfActivationForm
      : personalDetails
    : deliveryInfo;

  const deliveryAddOn =
    find(preActivationDeliveryAddon, {
      name: EXPRESS_DELIVERY
    }) ||
    find(preActivationDeliveryAddon, {
      name: SPECIAL_DELIVERY
    });
  // const id_upload_pending = get(personalDetails, "upload_id_later", false);

  let deliverySlotFee =
    get(deliveryForm, "shippingMethod.name") === SHIPMENT_METHOD.SELF_PICKUP
      ? get(deliveryForm, "selfPickUpLocation.deliveryFee", 0)
      : get(deliveryForm, "delivery_slot_fee", 0) ||
        get(deliveryAddOn, "price", 0);

  const deliverySlotItems = [];

  if (order?.state === get(ORDER_STATUS, "CREATED")) {
    deliverySlotFee = get(order?.slotFee, "price", 0);
  }
  if (deliverySlotFee > 0) {
    // const deliverySlot = find(deliveryHomeSlotType, { cost: deliverySlotFee });
    // const deliverySlotName = get(deliverySlot, "name", "");

    //kyc_delivery_fee condition added below to handle ESIM delivery fee label in order flow
    deliverySlotItems.push({
      label:
        get(deliveryForm, "shippingMethod.name") === SHIPMENT_METHOD.SELF_PICKUP
          ? get(locale, "self_pickup_fee", "")
          : get(connectionDetails, "sim_type") === SIM_TYPES.E_SIM
          ? get(locale, "kyc_delivery_fee", "")
          : get(locale, "pay_today_special_delivery_slot_fee", ""),
      price: formatCurrency(deliverySlotFee, currencyFormat, false),
      value: deliverySlotFee,
      type: "delivery"
    });
  }

  const phoneDetails = getPhoneDetailsForPayToday(phonesForm, currencyFormat);

  const allPayTodayItems = [
    ...payTodayItems,
    ...selectedNumberItem,
    ...deliverySlotItems,
    ...referralCodeBenefits,
    ...phoneDetails
  ];
  return filter(allPayTodayItems, item => item.value !== 0);
};

export const mapAddressComponentOption = (component = {}) => ({
  label: component.name,
  value: component.id
});

export const getChannelFromUrl = () => {
  const urlParts = get(window, "location.pathname", "").split("/");
  const channel = urlParts.length > 1 ? urlParts[1] : "web";
  return channel;
};

export const getLoginTypefromUrl = () => {
  const urlParts = get(window, "location.pathname", "").split("/");
  const loginType = urlParts.length > 1 ? urlParts[2] : "login";
  return loginType;
};

export const getNumberType = ({ sku, isPortIn }) => {
  const numberType = {
    "TEL-NUMGEN": "free_number",
    "TEL-NUMSLVR": "silver_number",
    "TEL-NUMGOLD": "golden_number"
  };
  return isPortIn ? "portin_number" : get(numberType, sku, "new_number");
};

export const canAllowAction = (action, steps) =>
  RESTRICTED_STEP_ACTIONS.includes(action)
    ? !isEmpty(
        find(steps, step =>
          isArray(step.action)
            ? step.action.includes(action)
            : step.action === action
        )
      )
    : true;

export const getActionUrl = (action = "", orderChannel = "web") => {
  const channel = WEB_CHANNELS.includes(orderChannel) ? "web" : orderChannel;
  const url = get(ACTION_URLS, lower(action), "");
  return url.replace(":channel", channel).replace(":type", action);
};

export const getPaymentStatusUrl = (status = "") => {
  const url = get(PAYMENT_STATUS_URLS, lower(status), paths.PAYMENT_STATUS);
  return url.replace(":channel", getChannelFromUrl());
};

export const getPaymentStatusUrlCXOS = (status = "") => {
  const url = get(
    PAYMENT_STATUS_URLS_CXOS,
    lower(status),
    paths.PAYMENT_STATUS
  );
  return url.replace(":channel", getChannelFromUrl());
};

export const constructOrderDetails = (
  details,
  paymentStatus,
  numberFormat,
  locale,
  slot,
  shippingLocationDetails,
  shippingMethodDetails,
  orderParams
) => {
  if (isEmpty(details) && isEmpty(paymentStatus)) return null;

  const initialShipmentDetails = get(details, "initial_shipment_details");

  const addressDetails = {
    ...get(
      details,
      "initial_shipment_details",
      get(orderParams, "deliver_detail", {})
    ),
    ...get(details, "order_delivery_detail")
  };

  const billingAddressDetails = get(
    details,
    "order_billing_detail",
    get(orderParams, "deliver_detail", {})
  );
  const deliveryAddress = constructLocalizedDeliveryAddress(
    addressDetails,
    locale,
    "delivery_address_label"
  );

  const billingAddress = constructLocalizedBillingAddress(
    billingAddressDetails,
    locale
  );

  const deliveryAddressHtml = constructLocalizedDeliveryAddress(
    addressDetails,
    locale,
    "delivery_address_html_format"
  );

  const selected_number = get(
    details,
    "selected_number",
    get(orderParams, "selected_number")
  );
  const selectedNumber = formatDisplayNumber(selected_number, numberFormat);
  const countryCode = get(
    details,
    "country_code",
    get(orderParams, "user_detail.country_code")
  );
  const current_contact_number = get(
    details,
    "customer_current_contact_number",
    get(orderParams, "user_detail.customer_current_contact_number")
  );
  const alternate_contact_number = get(
    details,
    "contact_number",
    get(orderParams, "user_detail.phone_number")
  );
  const contact_number = current_contact_number || alternate_contact_number;
  const contactNumber = formatContactNumber(
    contact_number,
    numberFormat,
    countryCode
  );
  const currentContactNumber = formatContactNumber(
    current_contact_number,
    numberFormat,
    countryCode
  );
  const alternateContactNumber = formatDisplayNumber(
    alternate_contact_number,
    numberFormat,
    countryCode
  );

  const slotData = get(
    details,
    "delivery_slot_full_data",
    get(orderParams, "delivery_slot.delivery_slot_full_data")
  );
  const slotDetails = constructLocalizedDeliverySlotDetails(slotData, locale);
  const { deliveryDate, deliveryTime } = slotDetails;
  const deliveryDateTime = constructDeliveryDateTime({
    deliveryDate,
    deliveryTime,
    locale
  });

  const deliveryDateAndTime = getFormattedDeliveryDateAndTime(
    slotData,
    null,
    slot,
    locale
  );
  const contactEmail = get(
    details,
    "contact_email",
    get(orderParams, "user_detail.email")
  );

  const firstName = get(
    details,
    "order_user_detail.first_name",
    get(orderParams, "user_detail.first_name")
  );
  const middleName = get(
    details,
    "order_user_detail.middle_name",
    get(orderParams, "user_detail.middle_name")
  );
  const lastName = get(
    details,
    "order_user_detail.last_name",
    get(orderParams, "user_detail.last_name")
  );
  const dateOfBirth = get(
    details,
    "order_user_detail.dob",
    get(orderParams, "user_detail.dob")
  );

  const name = compactJoin([firstName, middleName, lastName], " ");
  const postpaid = get(details, "postpaid");
  const portNumber = get(
    details,
    "port_number",
    get(orderParams, "portin_detail.port_number")
  );
  const isPortInRequest = get(details, "port_in_request", portNumber);
  const portDonor = get(
    details,
    "port_donor",
    get(orderParams, "portin_detail.port_donor")
  );
  const portinNumber = portNumber
    ? formatDisplayNumber(portNumber, numberFormat)
    : "";
  const portinNumberFromDonorMessage = get(
    locale,
    "portin_number_from_donor",
    "{portin_number} from {donor}"
  );
  const portinNumberFromDonor =
    portinNumber && portDonor
      ? formatMessage(portinNumberFromDonorMessage, {
          portin_number: portinNumber,
          donor: portDonor
        })
      : portinNumber;
  const idVerificationStatus = get(
    details,
    "order_product_info.idVerificationStatus"
  );
  const authorizeEnabled = get(details, "authorize_enabled", false);
  const authorizerName = get(details, "authoriser_name");
  let sameAsBillingAddress = false;
  if (billingAddress === deliveryAddress) {
    sameAsBillingAddress = true;
  }
  const selfPickupDetails = constructSelfPickupDetails(
    shippingLocationDetails,
    locale
  );
  const shippingDetails = constructShippingDetails(
    shippingMethodDetails,
    locale
  );

  const identityDocumentNumberExpiryDate = moment(
    get(details, "order_user_detail.identification_expiry_date")
  ).format("DD/MM/YYYY");

  const identityDocumentNumber = get(
    details,
    "order_user_detail.identification_number"
  );

  const deliveryInstructions = get(
    details,
    "initial_shipment_details.specialInstructions",
    ""
  );
  const nationality = get(details, "order_user_detail.nationality");
  const deliveryLandMark = get(
    details,
    "initial_shipment_details.landmark",
    ""
  );

  return {
    orderRef: get(details, "orderReference") || get(details, "order_ref"),
    items: get(details, "items"),
    steps: get(details, "steps", []),
    state: get(details, "state"),
    name: name?.trim(),
    firstName: firstName?.trim(),
    middleName: middleName?.trim(),
    lastName: lastName?.trim(),
    ...(dateOfBirth && {
      dateOfBirth: formatDateGlobal(new Date(dateOfBirth), {
        style: DATE_STYLES.SHORT
      }),
      dateOfBirthFormatted: formatDateGlobal(new Date(dateOfBirth), {
        style: DATE_STYLES.SHORT
      })
    }),
    contactEmail,
    contactNumber,
    currentContactNumber,
    alternateContactNumber,
    selectedNumber,
    portinNumber,
    portinNumberFromDonor,
    deliveryDate,
    deliveryTime,
    selfPickupDetails,
    shippingDetails,
    deliveryDateTime,
    deliveryDateAndTime,
    initialShipmentDetails,
    deliveryAddress,
    billingAddress,
    deliveryAddressHtml,
    deliveryActions: get(details, "delivery_actions", []),
    orderActions: get(details, "order_actions", []) ?? [],
    orderActionName: get(details, "order_action_name"),
    idVerificationStatus,
    isPortInRequest,
    postpaid,
    portDonor,
    idUploadPending: get(details, "id_upload_pending"),
    channel: get(details, "channel"),
    paymentStatus:
      get(details, "substates.PAYMENT.status") ||
      get(details, "payment_status"),
    trackingNumber: get(details, "tracking_number"),
    trackingUrl: get(details, "tracking_url"),
    simType: get(details, "sim_type"),
    contractType: get(details, "contract_type"),
    nextStep: get(details, "next_step"),
    authorizeEnabled,
    authorizerName,
    id: get(details, "id"),
    otpActionType: get(details, "otp_action_type"),
    kycOrgCode: get(details, "kyc_org_code", ""),
    sameAsBillingAddress,
    orderType: get(details, "order_type", ""),
    identityDocumentNumberExpiryDate,
    identityDocumentNumber,
    deliveryInstructions,
    nationality,
    deliveryLandMark,
    substates: get(details, "substates", {})
  };
};

export const constructDeliveryDateTime = ({
  deliveryDate,
  deliveryTime,
  locale
}) =>
  formatMessage(
    get(
      locale,
      "delivery_date_and_time_format",
      "{deliveryDate} {deliveryTime}"
    ),
    { deliveryDate, deliveryTime }
  ).trim();

export const flattenObject = (obj, prefix = "", separator = ".") => {
  let flattenedObject = {};
  try {
    flattenedObject = keys(obj).reduce((acc, k) => {
      const pre = prefix.length ? prefix + separator : "";
      if (typeof obj[k] === "object") {
        Object.assign(acc, flattenObject(obj[k], pre + k, separator));
      } else {
        acc[pre + k] = obj[k];
      }
      return acc;
    }, {});
  } catch (err) {
    console.log("error during flattenObject ", err);
  }

  return flattenedObject;
};

export const constructShippingDetails = (details, locale) => {
  return details?.name
    ? get(locale, `${details?.name}`)
    : get(locale, `${details}`);
};

export const constructSelfPickupDetails = (details, locale) => {
  const name = get(details, "address", "");

  // Removed other details except the name according to new figma design
  // const address = get(details, "address", "");
  // const zipcode = get(details, "zipcode", "");
  const operatingDaysOfWeek = get(details, "operatingDaysOfWeek", "");
  const operatingHours = get(details, "operatingHours", "");
  const htmlFormat = formatMessage(
    get(locale, "self_pickup_location_details"),
    { name, operatingDaysOfWeek, operatingHours }
  );
  return htmlFormat;
};

export const removeSensitiveData = data => {
  const sensitiveFieldsPattern = /(documents|nric|primary_id|secondary_id|token|auth|session_token|auth_token)/g;
  const fieldsToRemove = filter(keys(data), field => {
    const remove = field && field.match(sensitiveFieldsPattern);
    return remove;
  });
  for (const field of fieldsToRemove) {
    data[field] && delete data[field];
  }
  return data;
};

export const getGopayActionUrls = result => {
  const actions = get(result, "form_data.gopay.actions", []);
  const deepLinkUrl = get(find(actions, { name: "deeplink-redirect" }), "url");
  const qrCodeUrl = get(find(actions, { name: "generate-qr-code" }), "url");
  return { deepLinkUrl, qrCodeUrl };
};

export const generateHtmlElement = (key, value, type) => {
  const field = document.createElement("input");
  field.setAttribute("type", type);
  field.setAttribute("name", key);
  field.setAttribute("value", value);
  return field;
};

export const loadScript = (scriptName, url, callback) => {
  const existingScript = document.getElementById(scriptName);

  if (!existingScript) {
    const script = document.createElement("script");
    script.src = url;
    script.id = scriptName;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

export const removeScript = key => {
  const scriptElement = document.getElementById(key);
  if (scriptElement !== null) {
    scriptElement.remove();
  }
};

export const getDeviceType = () => {
  return isMobile() ? "Mobile" : "Web";
};

export const constructPhoneItem = phonesForm => {
  const { phoneVariant, phonePaymentOption } = phonesForm || {};
  if (phoneVariant && phonePaymentOption) {
    const { nameWithSpecs, sku } = phoneVariant;
    const {
      pay_monthly,
      pay_monthly_months,
      pay_monthly_total,
      pay_now,
      price,
      discount,
      monthly_discount,
      original_pay_now,
      original_pay_monthly
    } = get(phoneVariant, `paymentOption.${phonePaymentOption}`);

    return {
      item_type: "PHONE",
      quantity: 1,
      name: nameWithSpecs,
      sku,
      price,
      discount,
      monthly_discount,
      original_pay_now,
      original_pay_monthly,
      pay_now,
      pay_monthly,
      pay_monthly_months,
      pay_monthly_total
    };
  }
};

export const getPhoneDetailsForPayMonthly = (phonesForm, currencyFormat) => {
  const phoneItem = constructPhoneItem(phonesForm);
  const details = [];
  if (!isEmpty(phoneItem)) {
    details.push({
      type: "phone",
      label: "Monthly Phone Cost",
      value: phoneItem.pay_monthly,
      price: formatCurrency(phoneItem.original_pay_monthly, currencyFormat)
    });
    if (phoneItem.monthly_discount > 0) {
      details.push({
        type: "phone",
        benefit: true,
        label: "Phone Rebate",
        price: formatCurrency(-phoneItem.monthly_discount, currencyFormat, true)
      });
    }
    details.push({
      type: "phone",
      label: "Phone Payment Period",
      price: `${phoneItem.pay_monthly_months} months`
    });
  }
  return details;
};

export const getPhoneDetailsForPayToday = (phonesForm, currencyFormat) => {
  const phoneItem = constructPhoneItem(phonesForm);
  const details = [];
  if (!isEmpty(phoneItem)) {
    details.push({
      type: "phone",
      label: phoneItem.name,
      value: phoneItem.pay_now,
      price: formatCurrency(phoneItem.original_pay_now, currencyFormat)
    });
    if (phoneItem.discount > 0 && phoneItem.monthly_discount <= 0) {
      details.push({
        type: "phone",
        benefit: true,
        label: "Phone Rebate",
        price: formatCurrency(-phoneItem.discount, currencyFormat, true)
      });
    }
  }
  return details;
};

export const pathWithChannel = (path, channel) =>
  path
    .replace(":channel", channel || getChannelFromUrl())
    .replace(SIGNINTYPE, getLoginTypefromUrl);

export const nextPageWithParams = (path, selectedNumber, authToken) => {
  const msisdn = get(selectedNumber, "number");
  let nextPage = path;
  if (msisdn) {
    nextPage = addUrlParam("msisdn", msisdn, nextPage);
  }
  if (isWebview()) {
    nextPage = addUrlParam("auth_token", authToken, nextPage);
  }
  return nextPage;
};

export const formatAddressForPopStationItem = popStationInformation => {
  let unitNumber = get(popStationInformation, "unit_number", "");
  let storey = get(popStationInformation, "storey", "");
  let buildingName = get(popStationInformation, "building_name", "");
  let streetName = get(popStationInformation, "streetName", "");
  let country = get(popStationInformation, "country", "");
  let postalCode = get(popStationInformation, "postal_code", "");
  let formattedAddress = [];
  let orderedAddressParam = [
    unitNumber,
    storey,
    buildingName,
    streetName,
    country,
    postalCode
  ];

  formattedAddress = orderedAddressParam.filter(prop => {
    if (prop) return prop;

    return false;
  });

  return formattedAddress.join(", ");
};

export const autoScrollToError = () => {
  (() =>
    setTimeout(() => {
      let element = document.querySelectorAll(".field-error");
      if (element.length > 0) {
        element[0].scrollIntoView(true);
        let scrolledY = window.scrollY;
        if (scrolledY) {
          window.scroll({
            top: scrolledY - 150,
            left: 0,
            behavior: "smooth"
          });
        }
      }
    }, 0))();
};

export const getOutstandingBillReferralType = () => {
  let directTypeCondition = urlParam("token");

  let referralType = OUTSTANDING_BILL_REFERRAL_FROM_TYPE.MANAGE_ORDER;

  if (directTypeCondition)
    referralType = OUTSTANDING_BILL_REFERRAL_FROM_TYPE.DIRECT_LINK;

  return referralType;
};

export const scrollToDomNode = domNode => {
  if (domNode) {
    scrollIntoView(domNode, { behavior: "smooth", scrollMode: "if-needed" });
  }
};

//parse condition_variable into our regular condition string
export const parseConditionVariables = (
  appSettingConditions = {},
  conditionVariable = "",
  level = 1,
  _iteration = 0
) => {
  if (!conditionVariable) return "";

  let found = findCurlyBraceValues(conditionVariable);
  let condition =
    replaceCurlyBraceValues(found, conditionVariable, appSettingConditions) ||
    "";

  //check nested condition variable
  if (_iteration < level) {
    condition = parseConditionVariables(
      appSettingConditions,
      condition,
      level,
      _iteration + 1
    );
  }

  return condition;
};

export const findCurlyBraceValues = (conditionVariable = "") => {
  let found = [],
    reg = /{([^}]+)}/g,
    currentMatch;

  while ((currentMatch = reg.exec(conditionVariable))) {
    found.push(currentMatch[1]);
  }

  return found;
};

export const replaceCurlyBraceValues = (
  values = [],
  conditionVariable = "",
  appSettingConditions = {}
) => {
  let condition = conditionVariable;

  if (!appSettingConditions) return condition;

  values.forEach(value => {
    let appSettingCondition = appSettingConditions[value];
    condition = condition.replace(`{${value}}`, `${appSettingCondition}`);

    if (!appSettingCondition && typeof appSettingConditions !== "boolean")
      console.warn(
        `Invalid condition_variable - ${value}. Not defined in appSettings.conditions. Please check this condition_variable.`
      );
  });

  return condition;
};

export const adobeOrderItemsFormatter = (items, planName) =>
  items
    .filter(item => item.item_type !== "SIM")
    .map(item => ({
      quantity: 1,
      price: {
        basePrice: item.pay_now || 0
      },
      productInfo: {
        productID: item.sku,
        productCategory: item.item_type,
        planName: planName,
        productName: item.name,
        productBrand: "circles",
        productSize: "n/a",
        productColour: "n/a",
        productDescription: "n/a",
        productType: item.item_type,
        productDiscount: item.discount
      }
    }));

export const handleRelatedTargetAfterBlur = event => {
  event && event.persist();
  event &&
    event.relatedTarget &&
    !endsWith(event.relatedTarget.id, "_DropIdentity") &&
    event.relatedTarget.click();
};

/**
 * Controls if the country should support eligibility API in manage order
 * @returns {boolean} if the country is eligibility API supported
 */
export const isEligibilityAPISupported = () => {
  const ELIGIBILITY_API_SUPPORTED_COUNTRIES = ["JP", "CL"];
  const countryInUpperCase = process.env.REACT_APP_COUNTRY.toUpperCase();
  return ELIGIBILITY_API_SUPPORTED_COUNTRIES.includes(countryInUpperCase);
};
const selectOption = type => {
  switch (type) {
    case "f":
    case "full":
    case "upfront":
      return "full";
    case "ipp":
    case "z":
      return "installment";
    case "s":
      return "split";
    default:
      return;
  }
};
export const getPaymentOption = (type, options) => {
  const selectedOption = selectOption(type);
  const channel = getChannelFromUrl();
  const channelOption = get(options, channel, {});
  return get(channelOption, selectedOption, false)
    ? channelOption.default
    : selectedOption
    ? selectedOption
    : "full";
};

export const convertCamelCase = input => {
  const converted = input
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace(" ", "_")
    .toLowerCase();
  return converted;
};

export const getMyInfoAuthorisedURL = () => {
  const redirectUri = window.location.origin + window.location.pathname;

  const parameters = {
    client_id: MYINFO_CLIENT_ID || "",
    attributes: "uinfin,name,nationality,dob,email,mobileno,mailadd",
    purpose: "Circles.life mobile plan registration",
    state: redirectUri,
    redirect_uri: redirectUri
  };

  const authoriseUrl = queryString.stringifyUrl({
    url: MYINFO_ENDPOINT || "",
    query: parameters
  });

  return authoriseUrl;
};

export const removeQueryParams = (url = "", queryParamsToRemove = []) => {
  const parsedQuery = queryString.parse(window.location.search);
  let targetQuery = {};

  forEach(parsedQuery, (val, key) => {
    if (indexOf(queryParamsToRemove, key) === -1) {
      targetQuery[key] = val;
    }
  });

  return queryString.stringifyUrl({
    url: head(url.split("?")),
    query: targetQuery
  });
};

export const getDOBSecurityHeader = dob => {
  if (!dob) return {};
  const securityDOB = moment(dob, DOB_FORMAT).format(SECURITY_DOB_FORMAT);
  const dobDetails = JSON.stringify({ dateOfBirth: securityDOB });
  return { "X-SECURITY-CONTROL": window.btoa(dobDetails) };
};

export const getOTTSecurityHeader = (ott, requestId, sendService = false) => {
  if (!ott) return {};
  return {
    "X-SECURITY-CONTROL": "OTT",
    OTT: window.btoa(ott),
    "OTT-Request-Id": requestId,
    ...(sendService && { "Service-Id": "webfront" })
  };
};

/**
 * Generates headers required for UPDATE_USER_PROFLE ott API
 * In the future, should other headers be required for UPDATE_USER_PROFILE
 * simply include as a new parameter in the return object
 * (since sending invalid headers does not cause bugs)
 * @param {string} ott type of OTT
 * @param {object} payload payload from submission of form
 * @returns {object} required headers for UPDATE_USER_PROFILE ott API
 */
export const getOTTHeader = (ott, payload) => {
  if (!ott) return {};
  if (ott === PORTIN_NUMBER_VERFICATION) {
    const newNumber = get(payload, "port_in_number", "");
    return {
      "x-newNumber": window.btoa(newNumber) // base64conversion
    };
  }
  if (ott === "VERIFY_GUEST_USER") {
    const email = get(payload, "email", "");
    const contactNumber = get(payload, "contact_number", "");
    return {
      "x-guestEmail": email, // base64conversion
      "x-contactNumber": contactNumber
    };
  }
  const newEmail = get(payload, "new_email", "");
  return {
    "x-newEmail": window.btoa(newEmail) // base64conversion
  };
};

/**
 * Generates headers required for User Profile Update API
 * @param {string} ott ottcode
 * @param {string} requestId requestId from previous API call
 * @returns {object} required headers for User Profile Update API
 */
export const getUpdateUserProfileOTPHeader = (ott, requestId) => {
  if (!ott) return {};
  return {
    "x-ottCode": window.btoa(ott),
    "x-ottRequestId": window.btoa(requestId)
  };
};

export const isContainWhiteSpace = (value = "") => {
  const regex = /\s/;
  return regex.test(value);
};

export const splitJapaneseName = (japaneseName = "") => {
  const names = japaneseName.includes("　")
    ? japaneseName.split("　")
    : japaneseName.split(" ");
  return compact(names.map(name => trim(name, "　 ")));
};

export const constructLocalizedDateLabel = (
  currentDate,
  dateOptions,
  monthOptions,
  expiryDateLabelFormat
) => {
  const currentDay = currentDate.date();
  const currentMonth = currentDate.month() + 1;
  const currentYear = currentDate.year();
  const paddedDay = currentDay.toString().padStart(2, "0");
  const paddedMonth = currentMonth.toString().padStart(2, "0");
  const localizedDay =
    find(dateOptions, ["value", paddedDay])?.label || paddedDay;
  const localizedMonth =
    find(monthOptions, ["value", paddedMonth])?.label || paddedMonth;
  const label = expiryDateLabelFormat
    .replace("YYYY", currentYear)
    .replace("DD", localizedDay)
    .replace("MMM", localizedMonth)
    .replace("MM", localizedMonth);
  return label;
};

export const sanitizeHTML = html => DOMPurify.sanitize(html);

export const setNewRelicAttribute = (key, _value, securedBy = "") => {
  let value;

  if (isObject(_value)) {
    try {
      value = JSON.stringify(_value);
    } catch (e) {
      value = e.message;
    }
  } else {
    value = _value;
  }

  switch (securedBy?.toUpperCase()) {
    case "RSA":
      // reversible with private key
      value = getEncrypted(value);
      break;
    case "HASH":
      // non reversible
      value = getHash(value);
      break;
    default:
      break;
  }

  const setAttribute = window?.newrelic?.setCustomAttribute;
  if (isFunction(setAttribute) && key) {
    setAttribute(key, value ?? "N/A");
    console.debug("Setting newrelic attribute", { key, value });
  }
};

//    isLastDay = executeAt - currentTimeStamp <= 24 hours
export const isLastDay = timeStamp =>
  moment(timeStamp).diff(moment(), "hours") <= 24;

export const contructTerminationStatusStep = (
  eligibilityActionsStatus,
  locale,
  orderTerminationStatus,
  order
) => {
  let terminationStatusStep;
  const accountTerminationStatus = upper(
    get(orderTerminationStatus, "terminationStatus.status")
  );
  const isOrderStateTFL = get(order, "state") === TELCO_ACTIVATION_FAILED;
  const isLast = isOrderStateTFL
    ? false
    : isLastDay(get(orderTerminationStatus, "terminationStatus.executeAt"));
  const terminationDescription = isLast
    ? formatMessage(get(locale, "termination_action_description_last_day"))
    : formatMessage(get(locale, "termination_action_description"));
  if (isOrderStateTFL) {
    //STATE= TFL- telco failed
    if (TERMINATION_PENDING_STATUSES.includes(accountTerminationStatus)) {
      const terminationProcessing = formatMessage(
        get(locale, "telco_activation_failed_cancellation")
      );
      terminationStatusStep = {
        state: "processing",
        title: terminationProcessing
      };
    } else if (accountTerminationStatus === TERMINATION_COMPLETED_STATUS) {
      const terminatedTitle = formatMessage(
        get(locale, "telco_activation_failed_termination")
      );
      terminationStatusStep = { state: "fail", title: terminatedTitle };
    }
  } else {
    if (
      TERMINATION_PENDING_STATUSES.includes(accountTerminationStatus) &&
      !get(eligibilityActionsStatus, "cancel_account_termination.eligible")
    ) {
      // ! Termination is SCHEDULED FOR TODAY, WITHIN 24 Hours, CANCEL TERMINATION becomes  FALSE again.
      const terminationTitle = formatMessage(
        get(locale, "pending_account_termination")
      );

      terminationStatusStep = {
        state: "processing",
        title: terminationTitle,
        description: terminationDescription
      };
    } else if (
      TERMINATION_PENDING_STATUSES.includes(accountTerminationStatus) &&
      get(eligibilityActionsStatus, "cancel_account_termination.eligible")
    ) {
      const terminationTitle = formatMessage(
        get(locale, "pending_account_termination")
      );

      terminationStatusStep = {
        state: "processing",
        title: terminationTitle,
        description: terminationDescription,
        ...(!isLast && { action: ORDER_ACTION_TYPES.CANCEL_TERMINATION }) //display cancel termination button untill it is last day.
      };
    } else if (accountTerminationStatus === TERMINATE_ACTION_STATUS.FAIL) {
      const terminationFail = formatMessage(get(locale, "termination_fail"));
      terminationStatusStep = { state: "fail", title: terminationFail };
    } else if (accountTerminationStatus === TERMINATION_COMPLETED_STATUS) {
      const terminatedTitle = formatMessage(get(locale, "account_terminated"));
      terminationStatusStep = { state: "fail", title: terminatedTitle };
    }
  }
  return terminationStatusStep;
};

export const isAccountTerminated = (userEligibility, userDetails) => {
  const sim_only_order_eligible = get(
    userEligibility,
    "sim_only_order.eligible"
  );
  const telcoActiveStatus = !get(userDetails, "telco_info.status");
  const telcoTerminatedStatus =
    get(last(get(userDetails, "deleted_telco_info", [])), "status") ===
    get(TELCO_STATUS, "TERMINATED");
  return sim_only_order_eligible && telcoActiveStatus && telcoTerminatedStatus;
};

export const contructPortoutStatusStep = (eligibilityActionsStatus, locale) => {
  let portoutStatusStep;
  const portoutStatus = upper(get(eligibilityActionsStatus, "portout.status"));

  if (PORTOUT_PENDING_STATUSES.includes(portoutStatus)) {
    let portoutStatusMessage = formatMessage(get(locale, "mnp_being_issued"));
    let portoutValidityMessage = formatMessage(get(locale, "mnp_will_be_sent"));

    if (PORTOUT_IN_PROGRESS === portoutStatus) {
      // if date is not available moment will pick the curent date
      const valid_until_date = moment(
        get(eligibilityActionsStatus, "portout.transactionIdValidity")
      ).format("YYYY/MM");
      const mnp_reservation_number = get(
        eligibilityActionsStatus,
        "portout.mnp_reservation_number"
      );
      const values = {
        mnp_reservation_number,
        valid_until_date
      };
      portoutStatusMessage = formatMessage(get(locale, "mnp_issued"));
      portoutValidityMessage = formatMessage(
        get(locale, "portout_validity_message_with_mnp"),
        values
      );
    }
    portoutStatusStep = {
      state: "processing",
      title: portoutStatusMessage,
      description: portoutValidityMessage
    };
  } else if (PORTOUT_FAILED_STATUSES.includes(portoutStatus)) {
    const portoutFail = formatMessage(get(locale, "portout_failed"));
    portoutStatusStep = { state: "fail", title: portoutFail };
  } else if (PORTOUT_COMPLETED_STATUSES.includes(portoutStatus)) {
    portoutStatusStep = {
      state: "success",
      title: formatMessage(get(locale, "portout_success"))
    };
  }

  return portoutStatusStep;
};

export const generateRandomNumber = (numDigits = 1) => {
  /**
   * Generate random number of numDigits length.
   * @param {number} numDigits Desired number of digits of random number. Default to generate 1 number.
   * @return {number} A random integer of numDigits length
   */
  const dotIndex = 2;
  const numberLengthIndex = dotIndex + numDigits;

  if (
    numDigits <= 0 ||
    !Number.isInteger(numDigits) ||
    !(typeof numDigits === "number")
  )
    return; // only accept number datatype and integers

  const num = Math.random()
    .toString()
    .substring(dotIndex, numberLengthIndex); // construct random number
  return num;
};

/**
 * Returns URL params object required for user details API
 * @returns {object} user details url params object
 */
export const loggedInUserDetailsAPIParams = () => ({
  include_telco: true,
  include_ekyc: true,
  include_social: PORTING_ACCOUNTS,
  include_deleted_telco: true
});

/**
 * Returns portin providers as an array
 * @returns {Array} portin providers
 */
export const portinProviders = () => {
  if (isEmpty(PORTING_ACCOUNTS)) return [];
  else return PORTING_ACCOUNTS.split(",");
};

export const getDeepLink = () =>
  (isQAApp() && MOBILE_APP_DEEP_LINK_QA) || MOBILE_APP_DEEP_LINK;

/**
 * Calls webview specific url to update app with new token
 * @param {string} auth_token token value to update back to app
 * @returns void
 */
export const updateTokenToApp = (auth_token, silentAppLogin = false) => {
  if (!isWebview()) return;

  try {
    const params = {
      ...(silentAppLogin ? { silent_login_token: auth_token } : { auth_token }),
      deviceId: getDeviceId()
    };
    gotoUrl(UPDATE_TOKEN_TO_APP_URI, false, params);
  } catch (e) {
    console.error("Failed to update token to app", e);
  }
};

/**
 * Calls webview-specific url to send analytics data to mobile
 * @param {string} data analytics object to be sent to app
 * @returns void
 */
export const sendAnalyticsDataToApp = (data = {}) => {
  if (!isWebview()) {
    try {
      isFunction(window?.branch?.logEvent) &&
        window.branch.logEvent(
          get(data, "branch_standard_event"),
          get(data, "data")
        );
    } catch (e) {
      console.error("Failed to send data to Branch IO", e);
    }
    return;
  } else {
    try {
      gotoUrl(SEND_DATA_TO_APP_URI, false, {
        data_analytics: encodeURIComponent(JSON.stringify(data))
      }); // pass data analytics data via query params to mobile
    } catch (e) {
      console.error("Failed to send data to app", e);
    }
  }
};

export const getEncrypted = value => {
  if (!value) return value;

  const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCoZW6o/z9llhLaHBvKewHJWZt
  G8DbmVnuR2PaIJp/0dm6wwX9l41uC/rmcbvLWwMHE+Z+Whc78bHvhXTuRf5EUrAu
  ABzNyy8WYpQzF6r6ju0JfbrFb10uLcLtF+wsefjmWE9Fs9xPyuHRNneqfNNiN3wD
  js0nAkbZujJABfTcRQIDAQAB
  -----END PUBLIC KEY-----`;

  try {
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(PUBLIC_KEY);
    const encryptedValue = encrypt.encrypt(value);

    console.debug("encryptedValue: ", encryptedValue);
    return encryptedValue;
  } catch (e) {
    console.error("Encryption failed:", e);
    return;
  }
};

export const getHash = value => {
  if (!value) return value;

  const hashedValue = CryptoJS.SHA256(value).toString();
  console.debug("hashedValue: ", hashedValue);
  return hashedValue;
};

export const sortAndFilterOrders = userOrders =>
  orderBy(userOrders, ["id"], ["asc"]);

export const orderFormFields = (fields, key, order) => {
  return orderBy(
    Object.keys(fields).map(field => {
      return {
        ...fields[field],
        field
      };
    }),
    [key],
    [order]
  );
};

export const handleKyc = (stateProps, dispatchProps) => {
  const isManualEkyc = get(stateProps, "ekycSettings.manual_ekyc", false);
  const order = get(stateProps, "order");
  if (isManualEkyc) {
    return gotoUrl(`${paths.MANAGE_MANUAL_EKYC}?order_ref=${order.orderRef}`);
  }

  const deeplink = getDeepLink();
  const bodyParams = {
    order_id: stateProps.orderRef,
    redirect_url: isWebview()
      ? `${deeplink}${paths.WEBLOGIN}`
      : `${window.location.origin}${paths.USER_DETAILS}`
  };

  const onSuccess = (result, errors, status) => {
    const liquidUrl = get(result, "application_url");
    if (!errors && liquidUrl) {
      const finalUrl = isWebview()
        ? liquidUrl.replace("https", MOBILE_APP_BROWSER_PROTOCOL)
        : liquidUrl;

      gotoUrl(finalUrl);
    } else {
      if (status === 409) {
        gotoUrl(paths.USER_DETAILS);
      }
    }
  };

  dispatchProps.fetchLiquidUrl(bodyParams, onSuccess);
};

/**
 * Extracts file extension
 * @param {string} filename A filename ending with an extension (.jpg, .jpeg, .png, etc.)
 * @returns {string}
 */
export const getFileExtension = filename => filename.split(".").pop();

export const attachImagesToFormData = async (
  attachments,
  formData,
  formValues,
  docMapData
) => {
  let formField;
  let image;
  let imageDate;

  for (let attachment of attachments) {
    if (!isEmpty(docMapData)) {
      formField = docMapData[attachment];
      image = formValues[formField];
      imageDate = formValues[`${formField}_data`];
    } else if (formValues[attachment]) {
      image = formValues[attachment];
      imageDate = formValues[`${attachment}_data`];
    }

    if (image) {
      const res = await fetch(image);
      const blob = await res.blob();
      const file = new File([blob], imageDate.name, {
        type: imageDate.type,
        path: imageDate.path
      });
      formData.append(attachment, file);
    }

    image = "";
    imageDate = "";
    formField = "";
  }
};

export const failureReasonConstructor = (
  failureReasons,
  reasonEndmessage,
  locale
) => {
  let FailureReason = head(failureReasons.split(",")); // only first reason is needed NAME_MISMARCH,DOCYMENT
  let ReasonLocalized = get(locale, FailureReason, failureReasons); // use custom reason if localization of reason does not exist
  ReasonLocalized =
    ReasonLocalized && last(ReasonLocalized) !== "."
      ? `${ReasonLocalized}.`
      : ReasonLocalized; // add period if it does not exist
  let FailureEndMessage = get(locale, reasonEndmessage); // second part of full kyc failure reason
  let completeFailureReason = FailureEndMessage
    ? `${ReasonLocalized} ${FailureEndMessage}`
    : ReasonLocalized;
  return formatMessage(completeFailureReason);
};

export const fileTypeMapper = (types = []) =>
  types.map(type => FILE_TYPE_MAP[type.toUpperCase()]);

export const getBrowserPermissionStatus = async (
  queryName = BROWSER_PERMISSION_QUERY_NAMES.CAMERA
) => {
  return await navigator.permissions
    .query({ name: queryName })
    .then(({ state }) => ({ state }))
    .catch(e => {
      // For firefox browser it comes to catch part due to the broeser support issue.
      if (queryName === BROWSER_PERMISSION_QUERY_NAMES.CAMERA) {
        return new Promise((resolve, reject) => {
          navigator.mediaDevices
            .getUserMedia({ video: true })
            .then(stream => resolve({ state: "granted", stream }))
            .catch(err => {
              if (err.name === "NotAllowedError") {
                resolve({ state: "denied" });
              } else {
                reject(err);
              }
            });
        });
      }
    });
};

export const getPromocodeBenefits = promoDetails => {
  let benefits = get(promoDetails, "benefits", []).reduce((acc, current) => {
    if (acc) acc = `,${acc}`;
    return `${current.title}${acc}`;
  }, "");
  return {
    promocode_type: get(promoDetails, "referral_code_type"),
    promocode: get(promoDetails, "referral_code"),
    promo_campaign: get(promoDetails, "title", ""),
    benefits
  };
};

/**
 * @param {string} text Text to truncate
 * @param {number} charLimit Limit at which truncate happens
 * @param {boolean} removeSpacing If last part of truncatedText includes spacing, remove the spacing and do not truncate
 * Eg. Limit is 6 characters
 * if removeSpacing = true
 * "Allan Walker" will become "Allan" instead of "Allan ..."
 */
export const truncateText = (text, charLimit = 27, removeSpacing = true) => {
  if (text.length <= charLimit) return text;
  let subText = text.slice(0, charLimit);
  if (removeSpacing && subText.slice(-1) === " ") {
    return subText.slice(0, -1);
  }
  return subText + "...";
};

export const isAvailableNumberAndDeliverySlots = numberAndDeliverySlotAvailability =>
  !some(numberAndDeliverySlotAvailability, { available: false });

export const totalPlanAndAddonDiscount = benefits => {
  return benefits;
};

export const getPlanBenefits = plan => {
  const { benefits } = plan;
  return benefits;
  // filter(benefits, benefit =>
  //   includes(PLAN_BENEFITS_TYPES, benefit.selectedType)
  // );
};

export const getUniqueListBy = (arr, key) => {
  return [...new Map(arr.map(item => [item[key], item])).values()];
};
export const createConsentPayload = (
  userFlow,
  documentName,
  email = null,
  productId = null,
  consentType = "CHECKBOX"
) => {
  return {
    version: 2,
    userFlow: userFlow,
    documentName: documentName,
    productId: productId,
    consentGivenAt: new Date().getTime(),
    consentType: consentType,
    email: email,
    appVersion: "WEB"
  };
};

export const retry = (fn, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }
          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export const isMultiLineEligible = orderList => {
  const order = orderList?.length
    ? find(
        orderList,
        order =>
          !includes(ELIGIBLE_ORDER_STUTSES, order.state) &&
          order.order_type === ORDER_TYPES.SIM_ONLY
      )
    : [];
  return isEmpty(order) ? true : false;
};

export const isMultiLineEligibleDisableFields = orderList => {
  const order = orderList?.length
    ? find(
        orderList,
        order =>
          includes(TELCO_ACTIVATION_SUCCESS, order.state) &&
          order.order_type === ORDER_TYPES.SIM_ONLY
      )
    : [];
  const isMultiLineflg = !isEmpty(order) && orderList;
  return isMultiLineflg;
};
export const multiLineTelcoInfoStatus = (telcoInfoArray, status) => {
  if (!isEmpty(telcoInfoArray)) {
    if (telcoInfoArray.length === 1) {
      return telcoInfoArray[0].status === status;
    } else {
      return telcoInfoArray.some(item => item.status === status);
    }
  }
};

export const haveActiveOrders = orderList => {
  const order = orderList?.length
    ? find(
        orderList,
        order =>
          includes(TELCO_ACTIVATION_SUCCESS, order.state) &&
          order.order_type === ORDER_TYPES.SIM_ONLY
      )
    : [];
  return !isEmpty(order) ? true : false;
};

export const allMultiLineEligibleOrders = orderList => {
  const orders = orderList?.length
    ? orderList.filter(
        order =>
          ELIGIBLE_ORDER_STUTSES.includes(order.state) &&
          order.order_type === ORDER_TYPES.SIM_ONLY
      )
    : [];
  return !isEmpty(orders) ? orders : [];
};

export const generateGa4Data = () => {};

export const isOldRetryPayment = flowInfo => {
  return (flowInfo?.from === JOURNEY_FLOW.OLD_APP_VERSION ||
    flowInfo?.from === JOURNEY_FLOW.RETRY) &&
    !flowInfo?.isAvailablePersonalInfo
    ? true
    : false;
};

export const isAddingEasyPaisa = () => {
  return urlParam("show_processing") === "true" ? true : false;
};

export const displayProductLabel = (validity, frequency) => {
  const freqqval = frequency === "" || !frequency ? validity : frequency;
  const displayvalue = floor(validity / freqqval);

  let labelvalue = "";
  if (
    freqqval === "31" ||
    freqqval === "30" ||
    validity === "30" ||
    validity === "31"
  ) {
    if (displayvalue <= 1) {
      labelvalue = GROUP_PRODUCT_FREQUENCY_MAPPING.MONTHLY;
    } else {
      labelvalue = displayvalue + " " + GROUP_PRODUCT_FREQUENCY_MAPPING.MONTHS;
    }
  } else if (
    freqqval === "7" ||
    freqqval === "8" ||
    validity === "7" ||
    validity === "8"
  ) {
    if (displayvalue <= 1) {
      labelvalue = GROUP_PRODUCT_FREQUENCY_MAPPING.WEEKLY;
    } else {
      labelvalue = displayvalue + " " + GROUP_PRODUCT_FREQUENCY_MAPPING.WEEKS;
    }
  }

  return labelvalue;
};

export const getLocationBasedPromo = (benefits, city) => {
  let promoArr = [];
  if (!isEmpty(benefits)) {
    forEach(benefits, item => {
      if (
        item?.eligibilityCriteria?.customerLocation?.some(
          loc => loc?.toLowerCase() === city?.toLowerCase()
        )
      ) {
        promoArr.push(item?.title);
      }
    });
  }
  return promoArr;
};

export function getDisabledImageURL(imageURL = undefined) {
  const imgParts = imageURL.split("/");
  let imgName = imgParts && imgParts.pop();
  const [name, ext] = imgName.split(".");
  return `${AWS_IMAGE_PATH}${name}_disabled.${ext}`;
}

export const getV2WFUrl = path => {
  return WEBFRONT_V2_URL + path;
  // return "http://localhost:3000" + path
};

export const simActivationNavigationHandle = (path, token, orderRef) => {
  const v2SimActivationPath = `${getV2WFUrl(
    path
  )}?reset=true&device_id=${getDeviceId()}&auth_token=${token}&order_ref=${orderRef}${isWebViewParam()}`;
  window.location.href = v2SimActivationPath;
};

export const simRescheduleNavigationHandle = (path, token, orderRef) => {
  const v2SimActivationPath = `${getV2WFUrl(
    path
  )}reset=true&device_id=${getDeviceId()}&auth_token=${token}&order_ref=${orderRef}${isWebViewParam()}`;
  window.location.href = v2SimActivationPath;
};

export const getSlotsForMax21Or7Days = availableSlots => {
  const slots = availableSlots;

  const filteredSlots = slots
    .filter(slot => slot && slot.date && slot.price) // Filter out invalid slots
    .reduce((acc, slot) => {
      const lastDate = acc.length > 0 ? acc[acc.length - 1].date : null;

      // If a new date, count it toward day limit
      if (slot.date !== lastDate) {
        acc.dayCount = (acc.dayCount || 0) + 1;
      }

      // If 21 slots or 7 unique days reached, stop adding
      if (acc.length < 21 && acc.dayCount <= 7) {
        acc.push(slot);
      }

      return acc;
    }, []);

  return filteredSlots;
};

export const isWebViewParam = () => {
  return isWebview() ? "&webview=true" : "";
};

export const getCNICId = (kycInfo) => {
  const documentID = kycInfo?.attributes?.find(attr => attr.name === "documentId")?.value;
  const recipentDocumentID = kycInfo?.profiles?.find(profile => profile.profileType === "RECIPIENT")
    ?.attributes?.find(attr => attr.name === "documentId")?.value;
  // dont change order of OR condtion first need to check recipentDocumentID then documentID
   return recipentDocumentID || documentID || "";
};

export const getOSInfo = () => {
  const userAgent = navigator.userAgent;

  const regexMap = [
    { name: "Windows", pattern: /Windows NT (\d+\.\d+)/, versionReplacement: (v) => v },
    { name: "macOS", pattern: /Mac OS X (\d+_\d+_\d+)/, versionReplacement: (v) => v.replace(/_/g, ".") },
    { name: "iOS", pattern: /OS (\d+_\d+_\d+)/, versionReplacement: (v) => v.replace(/_/g, ".") },
    { name: "Android", pattern: /Android (\d+\.\d+)/, versionReplacement: (v) => v },
    { name: "Linux", pattern: /Linux/, versionReplacement: () => "Unknown Version" }
  ];

  for (const { name, pattern, versionReplacement } of regexMap) {
    const match = userAgent.match(pattern);
    if (match) {
      return {
        os: name,
        osVersion: versionReplacement(match[1] || "Unknown Version"),
      };
    }
  }

  return { os: "Unknown OS", osVersion: "Unknown Version" };
};

export const isMarketingWebNavigation = () => {
  const currentPath = window.location.pathname
  const isPidAvailable = !isEmpty(urlParam("planSku"));
  return currentPath === paths.ADDON_SELECTION.replace(":channel", "web") && isPidAvailable
};

export const stripHtmlTags = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.textContent || "";
};

export const isEpBind = () => {
  const showProcessing = urlParam("show_processing") === "true";
  const authState = urlParam("authState");
  const authCode = urlParam("paymentAuthCode");
  return showProcessing || (authState && authCode);
};

export const isDummyEmail = (userEmail) => {
  return userEmail?.includes("@email.com") || userEmail?.includes("@dummy.com")  ? "" : userEmail;
};